<style lang="scss" scoped>
.export-package {
    right: 10px;
    top: 3px;
}
.inbound-package {
    right: 6px;
    top: 3px;
}
</style>
<template>
    <div class="reimbursementUpdate">
        <compWrapper title="基本信息" theme="primary">
            <compFormQuery
                v-if="isQuery || isAdminQuery"
                class="margin-layout"
                :formdata="getBase"
                :value="formData"
            ></compFormQuery>
            <vButtonGroup class="absolute inbound-package">
                <vButton
                    v-if="handleAuth('fbb.reim.exportattach')"
                    theme="warning"
                    @click="downloadPackageLabel"
                    >{{ $t("", { defaultValue: "下载附件" }) }}</vButton
                >
            </vButtonGroup>
            <div
                class="reimbursementHead"
                style="margin-top: 20px"
                v-if="!isQuery && !isAdminQuery"
            >
                <vForm
                    class="margin-layout"
                    labelWidth="100"
                    v-model="formData"
                    ref="editform"
                >
                    <Row v-if="type !== 'add'">
                        <vCol span="12">
                            <vFormItem
                                label="索赔单号"
                                class="width-100per"
                                prop="reimbursementNo"
                            >
                                <span style="font-weight: bold">{{
                                    formData.reimbursementNo
                                }}</span>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="状态"
                                class="width-100per"
                                prop="status"
                            >
                                <span style="font-weight: bold">{{
                                    this.statusName
                                }}</span>
                            </vFormItem>
                        </vCol>
                    </Row>
                    <Row>
                        <vCol span="12">
                            <vFormItem
                                label="索赔类型"
                                class="width-100per"
                                prop="reimbursementType"
                                :rules="required"
                                v-if="type === 'add'"
                            >
                                <vSelect
                                    v-model="formData.reimbursementType"
                                    v-bind:disabled="disUse"
                                    filterable
                                    @on-change="changebursementType"
                                    clearable
                                >
                                    <vOption
                                        v-for="item in reimbursementTypeList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>

                            <vFormItem
                                label="索赔类型"
                                class="width-100per"
                                prop="reimbursementType"
                                v-if="type === 'edit'"
                            >
                                <span style="font-weight: bold">
                                    {{
                                        this.reimbursementTypeList.filter(
                                            (item) => {
                                                return (
                                                    item.value ==
                                                    this.formData
                                                        .reimbursementType
                                                );
                                            }
                                        )[0].label
                                    }}
                                </span>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="项目"
                                class="width-100per"
                                prop="lineId"
                                :rules="required"
                            >
                                <vSelect
                                    v-model="formData.lineId"
                                    filterable
                                    clearable
                                >
                                    <vOption
                                        v-for="item in getProductList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                        </vCol>
                    </Row>
                    <Row>
                        <vCol span="12">
                            <vFormItem
                                label="索赔原因"
                                class="width-100per"
                                prop="reimbursementReason"
                                :rules="required"
                                v-if="type === 'add'"
                            >
                                <vSelect
                                    v-model="formData.reimbursementReason"
                                    filterable
                                    @on-change="changereimbursementReason"
                                    clearable
                                >
                                    <vOption
                                        v-for="item in searchOptions.reimbursementReason"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                            <vFormItem
                                label="索赔原因"
                                class="width-100per"
                                prop="reimbursementReason"
                                v-if="type === 'edit'"
                            >
                                <span style="font-weight: bold">
                                    {{
                                        this.searchOptions.reimbursementReason.filter(
                                            (item) => {
                                                return (
                                                    item.value ==
                                                    this.formData
                                                        .reimbursementReason
                                                );
                                            }
                                        )[0].label
                                    }}
                                </span>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="来源单号"
                                class="width-100per"
                                prop="sourceNo"
                            >
                                <vInput
                                    v-model.trim="formData.sourceNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                    </Row>
                    <!-- 库存短少 -->
                    <div
                        class="invOos"
                        v-if="
                            formData.reimbursementType === 1 &&
                            (formData.reimbursementReason === 1 ||
                                formData.reimbursementReason === 13)
                        "
                    >
                        <vCol span="12">
                            <vFormItem
                                label="SKU"
                                class="width-100per"
                                prop="erpsku"
                                :rules="required"
                            >
                                <vInput
                                    v-model="props.erpsku"
                                    clearable
                                    @on-change="changeBySku"
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="短少数量"
                                class="width-100per"
                                prop="qty"
                                :rules="required"
                            >
                                <vInputNumber
                                    v-model="props.qty"
                                    @on-change="calculate"
                                    min="1"
                                    math="round"
                                    clearable
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="仓库"
                                class="width-100per"
                                prop="warehouseId"
                                :rules="required"
                            >
                                <vSelect
                                    v-model="props.warehouseId"
                                    @on-change="changerewarehouse"
                                    filterable
                                    clearable
                                >
                                    <vOption
                                        v-for="item in getWarehouseList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="DDP(USD)"
                                class="width-100per"
                                prop="ddp"
                                :rules="required"
                            >
                                <vInputNumber
                                    v-model="props.ddp"
                                    @on-change="calculate"
                                    min="0.0001"
                                    clearable
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="关联单号"
                                class="width-100per"
                                prop="relOrderNo"
                            >
                                <vInput
                                    v-model="props.relOrderNo"
                                    placeholder="可填写其他出库单号"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                    </div>
                    <!-- 订单异常平台罚款 -->
                    <div
                        class="whCancel"
                        v-if="
                            formData.reimbursementType === 1 &&
                            formData.reimbursementReason === 2
                        "
                    >
                        <vCol span="12">
                            <vFormItem
                                label="销售订单号"
                                class="width-100per"
                                prop="saleOrderNo"
                                :rules="required"
                            >
                                <vTextarea
                                    v-model="props.saleOrderNo"
                                    placeholder="多个订单号用,隔开"
                                    clearable
                                ></vTextarea>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="仓库"
                                class="width-100per"
                                prop="warehouseId"
                                :rules="required"
                            >
                                <vSelect
                                    v-model="props.warehouseId"
                                    @on-change="changerewarehouse"
                                    filterable
                                    clearable
                                >
                                    <vOption
                                        v-for="item in getWarehouseList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                        </vCol>
                    </div>
                    <!-- 仓库发错货 -->
                    <div
                        v-if="
                            formData.reimbursementType === 1 &&
                            formData.reimbursementReason === 3
                        "
                    >
                        <vCol span="12">
                            <vFormItem
                                label="处理方式"
                                class="width-100per"
                                prop="returnType"
                                :rules="required"
                                v-if="type === 'add'"
                            >
                                <vSelect v-model="props.returnType" clearable>
                                    <vOption
                                        v-for="item in searchOptions.returnType"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                            <vFormItem
                                label="处理方式"
                                class="width-100per"
                                prop="returnType"
                                v-if="type === 'edit'"
                            >
                                <span style="font-weight: bold">
                                    {{
                                        this.searchOptions.returnType.filter(
                                            (item) => {
                                                return (
                                                    item.value ==
                                                    this.props.returnType
                                                );
                                            }
                                        )[0].label
                                    }}
                                </span>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="发货订单号"
                                class="width-100per"
                                prop="shippingNo"
                                :rules="required"
                            >
                                <vInput
                                    v-model="props.shippingNo"
                                    placeholder="填写系统短单号"
                                    @on-change="changeOrderNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="发货仓库"
                                class="width-100per"
                                prop="warehouseId"
                                :rules="required"
                            >
                                <vSelect
                                    v-model="props.warehouseId"
                                    @on-change="changerewarehouse"
                                    filterable
                                    clearable
                                >
                                    <vOption
                                        v-for="item in getWarehouseList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                                <!-- <span>{{props.warehouseName}}</span> -->
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="发货Tracking"
                                class="width-100per"
                                prop="trackingNo"
                                :rules="required"
                            >
                                <vInput
                                    v-model.trim="props.trackingNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <div
                            v-if="
                                formData.reimbursementType === 1 &&
                                formData.reimbursementReason === 3 &&
                                props.returnType === 1
                            "
                        >
                            <vCol span="12">
                                <vFormItem
                                    label="退货售后单号"
                                    class="width-100per"
                                    prop="returnSaleOrderNo"
                                    :rules="required"
                                >
                                    <vInput
                                        v-model="props.returnSaleOrderNo"
                                        @on-change="changeByReturn"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="12">
                                <vFormItem
                                    label="退货Tracking"
                                    class="width-100per"
                                    prop="returnSaleOrderTrackingNo"
                                    :rules="required"
                                >
                                    <vInput
                                        v-model="
                                            props.returnSaleOrderTrackingNo
                                        "
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                        </div>

                        <vCol span="12">
                            <vFormItem
                                label="实发SKU"
                                class="width-100per"
                                prop="actualErpsku"
                            >
                                <vInput
                                    v-model="props.actualErpsku"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="实发数量"
                                class="width-100per"
                                prop="actualQty"
                                :rules="required"
                            >
                                <vInputNumber
                                    v-model="props.actualQty"
                                    clearable
                                    min="1"
                                    math="round"
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="实发SKU DDP(USD)"
                                class="width-100per"
                                prop="actualDdp"
                            >
                                <vInputNumber
                                    v-model="props.actualDdp"
                                    clearable
                                    min="0.0001"
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="应发SKU"
                                class="width-100per"
                                prop="shouldErpsku"
                                :rules="required"
                            >
                                <vInput
                                    v-model="props.shouldErpsku"
                                    clearable
                                    @on-change="changeBySku"
                                ></vInput>
                            </vFormItem>
                        </vCol>
                    </div>
                    <div
                        v-if="
                            formData.reimbursementReason === 1 ||
                            formData.reimbursementReason === 3 ||
                            formData.reimbursementReason === 13
                        "
                    >
                        <vCol span="12">
                            <vFormItem
                                label="FOB(USD)"
                                class="width-100per"
                                prop="fob"
                            >
                                <vInput v-model="props.fob" clearable></vInput>
                            </vFormItem>
                        </vCol>
                    </div>
                    <!-- 尾程 -->
                    <div
                        class="shipTail"
                        v-if="formData.reimbursementType === 2"
                    >
                        <vCol span="12">
                            <vFormItem
                                label="Tracking类型"
                                class="width-100per"
                                prop="trackingType"
                                :rules="required"
                                v-if="type === 'add'"
                            >
                                <vSelect v-model="props.trackingType" clearable>
                                    <vOption
                                        v-for="item in trackingTypeList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                            <vFormItem
                                label="Tracking类型"
                                class="width-100per"
                                prop="trackingType"
                                v-if="type === 'edit'"
                            >
                                <span style="font-weight: bold">
                                    {{
                                        this.trackingTypeList.filter((item) => {
                                            return (
                                                item.value ==
                                                this.props.trackingType
                                            );
                                        })[0].label
                                    }}
                                </span>
                            </vFormItem>
                        </vCol>

                        <vCol span="12">
                            <vFormItem
                                label="发货Tracking"
                                class="width-100per"
                                prop="trackingNo"
                                :rules="required"
                                v-if="props.trackingType === 1"
                            >
                                <vInput
                                    v-model.trim="props.trackingNo"
                                    @on-change="changeTrackingNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                            <vFormItem
                                label="退货Tracking"
                                class="width-100per"
                                prop="trackingNo"
                                :rules="required"
                                v-if="props.trackingType === 2"
                            >
                                <vInput
                                    v-model.trim="props.trackingNo"
                                    @on-change="findReturnByTrackingNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="发货订单号"
                                class="width-100per"
                                prop="shippingNo"
                                :rules="required"
                                v-if="props.trackingType === 1"
                            >
                                <vInput
                                    v-model="props.shippingNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                            <vFormItem
                                label="退货订单号"
                                class="width-100per"
                                prop="shippingNo"
                                :rules="required"
                                v-if="props.trackingType === 2"
                            >
                                <vInput
                                    v-model="props.shippingNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12" v-if="this.trackingShow == false">
                            <vFormItem
                                label="SKU"
                                class="width-100per"
                                prop="erpsku"
                                :rules="required"
                            >
                                <vInput
                                    v-model="props.erpsku"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12" v-if="this.trackingShow == true">
                            <vFormItem
                                label="SKU"
                                class="width-100per"
                                prop="erpsku"
                            >
                                <vInput
                                    v-model="props.erpsku"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>

                        <vCol span="12">
                            <vFormItem
                                label="发货Carrier"
                                class="width-100per"
                                prop="saleCarrier"
                                :rules="required"
                                v-if="props.trackingType === 1"
                            >
                                <vInput
                                    v-model.trim="props.saleCarrier"
                                    clearable
                                ></vInput>
                            </vFormItem>
                            <vFormItem
                                label="退货Carrier"
                                class="width-100per"
                                prop="saleCarrier"
                                :rules="required"
                                v-if="props.trackingType === 2"
                            >
                                <vInput
                                    v-model.trim="props.saleCarrier"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="物流服务"
                                class="width-100per"
                                prop="logisticsServiceCode"
                                :rules="required"
                            >
                                <vInput
                                    v-model.trim="props.logisticsServiceCode"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="数量"
                                class="width-100per"
                                prop="qty"
                                :rules="required"
                            >
                                <vInputNumber
                                    v-model="props.qty"
                                    clearable
                                    min="1"
                                    math="round"
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="DDP(USD)"
                                class="width-100per"
                                prop="ddp"
                                :rules="required"
                            >
                                <vInputNumber
                                    v-model="props.ddp"
                                    @on-change="handleAmount"
                                    clearable
                                    min="0.0001"
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="运费"
                                class="width-100per"
                                prop="shippingFee"
                                :rules="required"
                            >
                                <vInputNumber
                                    v-model="props.shippingFee"
                                    @on-change="handleAmount"
                                    clearable
                                    min="0.0001"
                                ></vInputNumber>
                            </vFormItem>
                        </vCol>
                    </div>
                    <!-- 账单 -->
                    <div class="bill" v-if="formData.reimbursementType === 3">
                        <vCol span="12">
                            <vFormItem
                                label="费用类型"
                                class="width-100per"
                                prop="billType"
                                :rules="required"
                                v-if="type === 'add'"
                            >
                                <vSelect v-model="props.billType" clearable>
                                    <vOption
                                        v-for="item in searchOptions.billType"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                            <vFormItem
                                label="费用类型"
                                class="width-100per"
                                prop="billType"
                                v-if="type === 'edit'"
                            >
                                <span style="font-weight: bold">
                                    {{
                                        this.searchOptions.billType.filter(
                                            (item) => {
                                                return (
                                                    item.value ==
                                                    this.props.billType
                                                );
                                            }
                                        )[0].label
                                    }}
                                </span>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="账单编号"
                                :rules="required"
                                class="width-100per"
                                prop="billNo"
                            >
                                <vInput
                                    v-model="props.billNo"
                                    clearable
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="管理方"
                                class="width-100per"
                                prop="hostOrgId"
                                :rules="required"
                            >
                                <vSelect
                                    v-model="formData.hostOrgId"
                                    filterable
                                    clearable
                                >
                                    <vOption
                                        v-for="item in getBeforeOrgList"
                                        :key="item.key"
                                        :value="item.value"
                                        >{{ item.label }}</vOption
                                    >
                                </vSelect>
                            </vFormItem>
                        </vCol>
                    </div>
                    <!-- 头程 -->
                    <div
                        class="shipHead"
                        v-if="formData.reimbursementType === 4"
                    >
                        <vCol span="12">
                            <vFormItem
                                label="入库计划单号"
                                class="width-100per"
                                prop="inBoundOrderNo"
                                :rules="required"
                            >
                                <vInput
                                    v-model="props.inBoundOrderNo"
                                    placeholder="多个用,隔开"
                                    clearable
                                    @on-change="changeInboundPlanOrderNos"
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="集装箱号"
                                class="width-100per"
                                prop="packedNo"
                            >
                                <vInput
                                    v-model="props.packedNo"
                                    clearable
                                    @on-change="changePackNo"
                                ></vInput>
                            </vFormItem>
                        </vCol>
                        <vCol span="12">
                            <vFormItem
                                label="仓库"
                                class="width-100per"
                                prop="warehouseName"
                            >
                                <span>{{ props.warehouseName }}</span>
                            </vFormItem>
                        </vCol>
                        <div
                            v-if="
                                formData.reimbursementType === 4 &&
                                formData.reimbursementReason === 12
                            "
                        >
                            <vCol span="12">
                                <vFormItem
                                    label="超期用箱工作日"
                                    class="width-100per"
                                    prop="overdueContainDay"
                                    :rules="required"
                                >
                                    <vInputNumber
                                        v-model="props.overdueContainDay"
                                        clearable
                                        min="0.0001"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="12">
                                <vFormItem
                                    label="滞箱费(USD)"
                                    class="width-100per"
                                    prop="containFee"
                                >
                                    <vInputNumber
                                        v-model="props.containFee"
                                        clearable
                                        min="0"
                                        @on-change="calculateFee"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="12">
                                <vFormItem
                                    label="车架费(USD)"
                                    class="width-100per"
                                    prop="frameFee"
                                >
                                    <vInputNumber
                                        v-model="props.frameFee"
                                        clearable
                                        min="0"
                                        @on-change="calculateFee"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="12">
                                <vFormItem
                                    label="其他费用(USD)"
                                    class="width-100per"
                                    prop="otherFee"
                                >
                                    <vInputNumber
                                        v-model="props.otherFee"
                                        clearable
                                        min="0"
                                        @on-change="calculateFee"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                        </div>
                    </div>
                    <vCol span="12">
                        <vFormItem
                            label="索赔金额(USD)"
                            class="width-100per"
                            prop="reimbursementAmount"
                            :rules="required"
                        >
                            <vInputNumber
                                v-model="formData.reimbursementAmount"
                                :disabled="formData.reimbursementType === 2"
                                clearable
                                min="0.0001"
                            ></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="12">
                        <vFormItem label="CC" class="width-100per" prop="CC">
                            <vInput
                                v-model="formData.sendEmail"
                                placeholder="审核拒回发送邮箱，多个邮箱用;分隔，举例:XXX@XXX.com;XXX@XXX.com"
                            />
                        </vFormItem>
                    </vCol>
                    <vCol
                        span="12"
                        v-if="this.formData.reimbursementReason !== 2"
                    >
                        <vFormItem
                            label="备注"
                            class="width-100per"
                            prop="remark"
                        >
                            <vTextarea
                                v-model="formData.remark"
                                clearable
                            ></vTextarea>
                        </vFormItem>
                    </vCol>
                    <vCol
                        span="12"
                        v-if="this.formData.reimbursementReason === 2"
                    >
                        <vFormItem
                            label="备注"
                            class="width-100per"
                            prop="remark"
                        >
                            <vTextarea
                                v-model="formData.remark"
                                clearable
                            ></vTextarea>
                        </vFormItem>
                    </vCol>
                    <vCol v-if="formData.reimbursementType === 2" span="12">
                        <vFormItem
                            class="width-100per prop-file-parent"
                            label="索赔文件"
                        >
                            <div>
                                <div class="reimbursementUpload">
                                    <div class="upload">
                                        <div
                                            class="upload-item"
                                            v-for="(
                                                item, index
                                            ) in propGoodsProve.items"
                                            :key="item.key"
                                        >
                                            <div class="filename">
                                                {{ item.attachTitle }}
                                            </div>
                                            <div>
                                                <Icon
                                                    class="close"
                                                    size="13"
                                                    type="md-close"
                                                    @click="
                                                        clearPropUpload3(index)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vButton
                                    theme="primary"
                                    @click="importPropFile1"
                                    ><span style="color: red; margin-right: 5px"
                                        >*</span
                                    >货值证明</vButton
                                >
                                <span
                                    class="props-file-text"
                                    v-if="this.tipShow1 == true"
                                    style="color: red"
                                    >货值证明不能为空,请填写</span
                                >
                            </div>
                            <div style="margin-top: 10px">
                                <div class="reimbursementUpload">
                                    <div class="upload">
                                        <div
                                            class="upload-item"
                                            v-for="(
                                                item, index
                                            ) in propDamageProve.items"
                                            :key="item.key"
                                        >
                                            <div class="filename">
                                                {{ item.attachTitle }}
                                            </div>
                                            <div>
                                                <Icon
                                                    class="close"
                                                    size="13"
                                                    type="md-close"
                                                    @click="
                                                        clearPropUpload4(index)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vButton
                                    theme="primary"
                                    @click="importPropFile2"
                                    ><span
                                        v-if="
                                            this.formData
                                                .reimbursementReason === 6
                                        "
                                        style="color: red; margin-right: 5px"
                                        >*</span
                                    >破损证明</vButton
                                >
                                <span
                                    class="props-file-text"
                                    v-if="
                                        this.tipShow2 == true &&
                                        this.formData.reimbursementReason === 6
                                    "
                                    style="color: red"
                                    >破损证明不能为空,请填写</span
                                >
                            </div>
                            <div style="margin-top: 10px">
                                <div class="reimbursementUpload">
                                    <div class="upload">
                                        <div
                                            class="upload-item"
                                            v-for="(
                                                item, index
                                            ) in propAttachMetas.items"
                                            :key="item.key"
                                        >
                                            <div class="filename">
                                                {{ item.attachTitle }}
                                            </div>
                                            <div>
                                                <Icon
                                                    class="close"
                                                    size="13"
                                                    type="md-close"
                                                    @click="
                                                        clearPropUpload(index)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vButton theme="primary" @click="importPropFile"
                                    >其他证明文件</vButton
                                >
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol v-if="formData.reimbursementType === 1" span="12">
                        <vFormItem
                            class="width-100per prop-file-parent"
                            label="索赔文件"
                        >
                            <div>
                                <div class="reimbursementUpload">
                                    <div class="upload">
                                        <div
                                            class="upload-item"
                                            v-for="(
                                                item, index
                                            ) in attachMetaA.items"
                                            :key="item.key"
                                        >
                                            <div class="filename">
                                                {{ item.attachTitle }}
                                            </div>
                                            <div>
                                                <Icon
                                                    class="close"
                                                    size="13"
                                                    type="md-close"
                                                    @click="
                                                        clearPropUpload5(index)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vButton
                                    theme="primary"
                                    @click="importPropFile5"
                                    ><span style="color: red; margin-right: 5px"
                                        >*</span
                                    >货值证明</vButton
                                >
                                <span
                                    class="props-file-text"
                                    v-if="this.tipShow5 == true"
                                    style="color: red"
                                    >货值证明不能为空,请填写</span
                                >
                            </div>
                            <div style="margin-top: 10px">
                                <div class="reimbursementUpload">
                                    <div class="upload">
                                        <div
                                            class="upload-item"
                                            v-for="(
                                                item, index
                                            ) in attachMetaB.items"
                                            :key="item.key"
                                        >
                                            <div class="filename">
                                                {{ item.attachTitle }}
                                            </div>
                                            <div>
                                                <Icon
                                                    class="close"
                                                    size="13"
                                                    type="md-close"
                                                    @click="
                                                        clearPropUpload6(index)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vButton
                                    theme="primary"
                                    @click="importPropFile6"
                                    >面单照片</vButton
                                >
                            </div>
                            <div style="margin-top: 10px">
                                <div class="reimbursementUpload">
                                    <div class="upload">
                                        <div
                                            class="upload-item"
                                            v-for="(
                                                item, index
                                            ) in attachMetaC.items"
                                            :key="item.key"
                                        >
                                            <div class="filename">
                                                {{ item.attachTitle }}
                                            </div>
                                            <div>
                                                <Icon
                                                    class="close"
                                                    size="13"
                                                    type="md-close"
                                                    @click="
                                                        clearPropUpload7(index)
                                                    "
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <vButton
                                    theme="primary"
                                    @click="importPropFile7"
                                    >外箱label照片</vButton
                                >
                            </div>
                        </vFormItem>
                    </vCol>
                    <vCol
                        span="12"
                        v-if="
                            this.formData.reimbursementType === 3 ||
                            this.formData.reimbursementType === 4
                        "
                    >
                        <vFormItem
                            label="附件上传"
                            class="width-100per"
                            :rules="required"
                        >
                            <span
                                v-if="
                                    this.formData.reimbursementType === 1 &&
                                    (this.formData.reimbursementReason === 1 ||
                                        this.formData.reimbursementReason ===
                                            13)
                                "
                                style="color: grey; font-size: 11px"
                                >请上传DDP价值证明</span
                            >
                            <span
                                v-if="
                                    this.formData.reimbursementType === 1 &&
                                    this.formData.reimbursementReason === 2
                                "
                                style="color: grey; font-size: 11px"
                                >请上传取消或换仓截图</span
                            >
                            <span
                                v-if="
                                    this.formData.reimbursementType === 1 &&
                                    this.formData.reimbursementReason === 3
                                "
                                style="color: grey; font-size: 11px"
                                >请上传发错货标签及箱唛图片、发错货面单图片，DDP价值证明</span
                            >
                            <span
                                v-if="
                                    this.formData.reimbursementType === 2 ||
                                    this.formData.reimbursementType === 3
                                "
                                style="color: grey; font-size: 11px"
                                >请上传相关文件</span
                            >
                            <span
                                v-if="
                                    this.formData.reimbursementType === 4 &&
                                    this.formData.reimbursementReason === 11
                                "
                                style="color: grey; font-size: 11px"
                                >请上传DDP价值证明文件,完整装柜照片,装柜视频线下发送</span
                            >
                            <span
                                v-if="
                                    this.formData.reimbursementType === 4 &&
                                    this.formData.reimbursementReason === 12
                                "
                                style="color: grey; font-size: 11px"
                                >上传超期用箱的证据以及各类额外费用的发票证明</span
                            >
                            <div class="reimbursementUpload">
                                <div class="upload">
                                    <div
                                        class="upload-item"
                                        v-for="(
                                            item, index
                                        ) in attachMetas.items"
                                        :key="item.key"
                                    >
                                        <div class="filename">
                                            {{ item.attachTitle }}
                                        </div>
                                        <div>
                                            <Icon
                                                class="close"
                                                size="13"
                                                type="md-close"
                                                @click="clearUpload(index)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <vButton theme="primary" @click="importFile"
                                >选择文件</vButton
                            >
                        </vFormItem>
                    </vCol>
                    <div
                        class="pull-right"
                        style="margin-right: 20px; margin-top: 70px"
                    >
                        <vButton
                            style="margin: 10px 5px"
                            theme="primary"
                            @click="submit(1)"
                            v-if="
                                formData.reimbursementType !== 3 &&
                                formData.reimbursementReason !== 11
                            "
                            >保存为草稿</vButton
                        >
                        <vButton
                            style="margin: 10px 5px"
                            theme="success"
                            @click="submit(2)"
                            v-if="
                                formData.reimbursementType !== 3 &&
                                formData.reimbursementReason !== 11
                            "
                            >提交审核</vButton
                        >
                        <vButton
                            style="margin: 10px 5px"
                            theme="primary"
                            @click="next"
                            v-if="
                                type === 'add' &&
                                (formData.reimbursementType === 3 ||
                                    formData.reimbursementReason === 11)
                            "
                            >下一步</vButton
                        >
                        <vButton
                            style="margin: 10px 5px"
                            v-if="
                                type === 'add' ||
                                (type === 'edit' &&
                                    formData.reimbursementType !== 3 &&
                                    formData.reimbursementReason !== 11)
                            "
                            @click="cancel"
                            >返回</vButton
                        >
                    </div>
                </vForm>
            </div>
        </compWrapper>

        <compWrapper
            title="索赔明细"
            theme="info"
            v-if="
                type === 'edit' &&
                (this.formData.reimbursementType == 3 ||
                    this.formData.reimbursementReason == 11)
            "
            v-model="formDetail"
        >
            <div class="reimbursementDetail" style="margin-top: 20px">
                <vForm labelWidth="100" ref="detailform">
                    <Row>
                        <div
                            v-if="
                                formData.reimbursementReason === 9 &&
                                props.billType !== 2
                            "
                        >
                            <vCol span="7.5">
                                <vFormItem
                                    label="计费单号/关联单据号"
                                    class="width-100per"
                                    prop="costNo"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.costNo"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="仓库"
                                    class="width-100per"
                                    prop="warehouseId"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vSelect
                                        v-model="detailProps.warehouseId"
                                        @on-change="changeDetailWarehouse"
                                        filterable
                                        clearable
                                    >
                                        <vOption
                                            v-for="item in getWarehouseList"
                                            :key="item.key"
                                            :value="item.value"
                                            >{{ item.label }}</vOption
                                        >
                                    </vSelect>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="索赔金额(USD)"
                                    class="width-100per"
                                    prop="reimbursementAmount"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vInputNumber
                                        v-model="formDetail.reimbursementAmount"
                                        clearable
                                        min="0.0001"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>

                            <vCol span="7.5">
                                <vFormItem
                                    label="备注"
                                    class="width-100per"
                                    prop="remark"
                                    labelWidth="140"
                                    style="margin-bottom: 15px"
                                >
                                    <vInput
                                        v-model="formDetail.remark"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="3.5" style="margin-left: 45px">
                                <vButton
                                    theme="primary"
                                    @click="addItem"
                                    style="margin: 0px 5px"
                                    >添加</vButton
                                >
                                <vButton
                                    theme="success"
                                    @click="importDetail"
                                    style="margin: 0px 5px"
                                    >导入</vButton
                                >
                            </vCol>
                        </div>
                        <div
                            v-if="
                                formData.reimbursementReason === 9 &&
                                props.billType === 2
                            "
                        >
                            <vCol span="7.5">
                                <vFormItem
                                    label="SKU"
                                    class="width-100per"
                                    prop="erpsku"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.erpsku"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="批次号"
                                    class="width-100per"
                                    prop="batchNo"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.batchNo"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="仓库"
                                    class="width-100per"
                                    prop="warehouseId"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vSelect
                                        v-model="detailProps.warehouseId"
                                        @on-change="changeDetailWarehouse"
                                        filterable
                                        clearable
                                    >
                                        <vOption
                                            v-for="item in getWarehouseList"
                                            :key="item.key"
                                            :value="item.value"
                                            >{{ item.label }}</vOption
                                        >
                                    </vSelect>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="索赔金额(USD)"
                                    class="width-100per"
                                    prop="reimbursementAmount"
                                    :rules="required"
                                    labelWidth="140"
                                    style="margin-bottom: 15px"
                                >
                                    <vInputNumber
                                        v-model="formDetail.reimbursementAmount"
                                        clearable
                                        min="0.0001"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="备注"
                                    class="width-100per"
                                    prop="remark"
                                    labelWidth="140"
                                    style="margin-bottom: 15px"
                                >
                                    <vInput
                                        v-model="formDetail.remark"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="3.5" style="margin-left: 45px">
                                <vButton
                                    theme="primary"
                                    @click="addItem"
                                    style="margin: 0px 5px"
                                    >添加</vButton
                                >
                                <vButton
                                    theme="success"
                                    @click="importDetail"
                                    style="margin: 0px 5px"
                                    >导入</vButton
                                >
                            </vCol>
                        </div>
                        <div v-if="formData.reimbursementReason === 10">
                            <vCol span="7.5">
                                <vFormItem
                                    label="Tracking"
                                    class="width-100per"
                                    prop="trackingNo"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.trackingNo"
                                        @on-blur="changeTrackingNoDetail"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="订单号"
                                    class="width-100per"
                                    prop="dispatchNo"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.dispatchNo"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="发货Carrier"
                                    class="width-100per"
                                    prop="saleCarrier"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.saleCarrier"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="SKU"
                                    class="width-100per"
                                    prop="erpsku"
                                    labelWidth="140"
                                >
                                    <vInput
                                        v-model="detailProps.erpsku"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="仓库"
                                    class="width-100per"
                                    prop="warehouseId"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vSelect
                                        v-model="detailProps.warehouseId"
                                        @on-change="changeDetailWarehouse"
                                        filterable
                                        clearable
                                    >
                                        <vOption
                                            v-for="item in getWarehouseList"
                                            :key="item.key"
                                            :value="item.value"
                                            >{{ item.label }}</vOption
                                        >
                                    </vSelect>
                                </vFormItem>

                                <!-- <vFormItem label="仓库:" class="width-100per" prop="warehouseName" labelWidth="140">
                  <span>{{this.detailProps.warehouseName}}</span>
                </vFormItem> -->
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="索赔金额(USD)"
                                    class="width-100per"
                                    prop="reimbursementAmount"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vInputNumber
                                        v-model="formDetail.reimbursementAmount"
                                        clearable
                                        min="0.0001"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="备注"
                                    class="width-100per"
                                    prop="remark"
                                    labelWidth="140"
                                    style="margin-bottom: 15px"
                                >
                                    <vInput
                                        v-model="formDetail.remark"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="3.5" style="margin-left: 45px">
                                <vButton
                                    theme="primary"
                                    @click="addItem"
                                    style="margin: 0px 5px"
                                    >添加</vButton
                                >
                                <vButton
                                    theme="success"
                                    @click="importDetail"
                                    style="margin: 0px 5px"
                                    >导入</vButton
                                >
                            </vCol>
                        </div>
                        <div v-if="formData.reimbursementReason === 11">
                            <vCol span="7.5">
                                <vFormItem
                                    label="SKU"
                                    class="width-100per"
                                    prop="erpsku"
                                    labelWidth="140"
                                    :rules="required"
                                >
                                    <vInput
                                        v-model="detailProps.erpsku"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="短少数量"
                                    class="width-100per"
                                    prop="qty"
                                    labelWidth="140"
                                    :rules="required"
                                >
                                    <vInputNumber
                                        v-model="detailProps.qty"
                                        @on-change="calculateDetail"
                                        min="1"
                                        math="round"
                                        clearable
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="DDP(USD)"
                                    class="width-100per"
                                    prop="ddp"
                                    labelWidth="140"
                                    :rules="required"
                                >
                                    <vInputNumber
                                        v-model="detailProps.ddp"
                                        @on-change="calculateDetail"
                                        min="0.0001"
                                        clearable
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="索赔金额(USD)"
                                    class="width-100per"
                                    prop="reimbursementAmount"
                                    :rules="required"
                                    labelWidth="140"
                                >
                                    <vInputNumber
                                        v-model="formDetail.reimbursementAmount"
                                        clearable
                                        min="0.0001"
                                    ></vInputNumber>
                                </vFormItem>
                            </vCol>
                            <vCol span="7.5">
                                <vFormItem
                                    label="备注"
                                    class="width-100per"
                                    prop="remark"
                                    labelWidth="140"
                                    style="margin-bottom: 15px"
                                >
                                    <vInput
                                        v-model="formDetail.remark"
                                        clearable
                                    ></vInput>
                                </vFormItem>
                            </vCol>
                            <vCol span="3.5" style="margin-left: 45px">
                                <vButton
                                    theme="primary"
                                    @click="addItem"
                                    style="margin: 0px 5px"
                                    >添加</vButton
                                >
                                <vButton
                                    theme="success"
                                    @click="importDetail"
                                    style="margin: 0px 5px"
                                    >导入</vButton
                                >
                            </vCol>
                        </div>
                    </Row>
                </vForm>
                <vButtonGroup class="margin-layout" style="margin-top: 0px">
                    <vButton @click="removeItems">删除</vButton>
                    <vButton @click="clearAll">清空</vButton>
                </vButtonGroup>
                <compTableList
                    class="margin-layout"
                    :columns="getInColumnsInv"
                    v-bind="getTableListProps"
                    ref="tableList"
                ></compTableList>
            </div>
            <div class="pull-right" style="margin-right: 20px">
                <vButton
                    style="margin: 10px 5px"
                    theme="primary"
                    @click="submit(1)"
                    v-if="type === 'edit'"
                    >保存为草稿</vButton
                >
                <vButton
                    style="margin: 10px 5px"
                    theme="success"
                    @click="submit(2)"
                    v-if="type === 'edit'"
                    >提交审核</vButton
                >
                <vButton
                    style="margin: 10px 5px"
                    v-if="type === 'edit'"
                    @click="cancel"
                    >返回</vButton
                >
            </div>
        </compWrapper>
        <compWrapper
            title="索赔明细"
            theme="primary"
            v-if="
                (isQuery || isAdminQuery) &&
                (this.formData.reimbursementType == 3 ||
                    this.formData.reimbursementReason == 11)
            "
        >
            <vButton
                class="absolute export-package"
                theme="success"
                @click="exportDetail"
                >导出明细</vButton
            >
            <vTableSimple
                class="margin-15"
                :columns="getInColumnsInv"
                :data="datalist"
                border
            ></vTableSimple>
        </compWrapper>
        <compWrapper
            title="操作历史"
            theme="gray"
            v-if="isQuery || isAdminQuery"
        >
            <vTableSimple
                class="margin-15"
                :columns="getLogColumns"
                :data="logList"
                border
            ></vTableSimple>
            <vButtonGroup slot="footer" v-if="!querytype">
                <vButton
                    v-for="item in getStatusBtns"
                    :key="item.name"
                    @click="item.run"
                    :theme="item.theme"
                    >{{ item.name }}</vButton
                >
            </vButtonGroup>
        </compWrapper>
        <vButtonGroup class="text-right" v-if="querytype">
            <vButton
                v-for="item in getStatusBtns"
                :key="item.name"
                @click="item.run"
                :theme="item.theme"
                >{{ item.name }}</vButton
            >
        </vButtonGroup>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compMutiUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="operate2.show"
            :title="operate2.title"
            v-bind="operate2"
        >
            <compMutiUpload
                v-bind="getFileProps2"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="operate3.show"
            :title="operate3.title"
            v-bind="operate3"
        >
            <compMutiUpload
                v-bind="getFileProps3"
                @on-success="aaasuccess3"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="operate4.show"
            :title="operate4.title"
            v-bind="operate4"
        >
            <compMutiUpload
                v-bind="getFileProps4"
                @on-success="aaasuccess4"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="operate5.show"
            :title="operate5.title"
            v-bind="operate5"
        >
            <compMutiUpload
                v-bind="getFileProps3"
                @on-success="aaasuccess5"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="operate6.show"
            :title="operate6.title"
            v-bind="operate6"
        >
            <compMutiUpload
                v-bind="getFileProps"
                @on-success="aaasuccess6"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vModal
            class="hidefooter customerupload"
            v-model="operate7.show"
            :title="operate7.title"
            v-bind="operate7"
        >
            <compMutiUpload
                v-bind="getFileProps"
                @on-success="aaasuccess7"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <!-- <vModal
      v-model="modalProps.show"
      :title="modalProps.title"
      :width="modalProps.width"
      :showFooter="false"
    ></vModal>-->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
        >
            <component
                :is="modalProps.component"
                @on-close="modalProps.show = false"
                v-on="modalProps.on"
                @refreshPage="refreshPage"
                v-bind="modalProps.props"
            ></component>
        </compModal>

        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import {
    HttpReimbursementDetail,
    HttpReimbursementSave,
    HttpReimbursementGetById,
    HttpReimbursementDetatilSave,
    HttpReimbursementRemove,
    HttpClearReimbursementDetail,
    HttplogOrderAction,
    HttpOrderId,
    HttpFindBySku,
    HttpReimbursements,
    HttpReturnByServiceNo,
    HttpFindOneByTrackingNo,
    HttpDelFile,
    HttpDelRelAttach,
    HttpAddRelAttach,
    HttpAddPropAttach,
    HttpDelPropAttach,
    HttpImportDetail,
    HttpReturnByOrderId,
    HttpInboundPlanOrderNos,
    HttpInboundPlanCheck,
    HttpGetReturnByTrackingNo,
    HttpGetFbbReturnByTrackingNo,
    HttpGetTrackingNoByLabel,
    HttpHosWarehouse,
    HttpGetBeforeOrgList,
    HttpExportClaimStatement,
    HttpFindByTrackingNoNew,
} from "@/service/reimbursement";
import mixin from "./mixin";
import { mapGetters } from "vuex";
import compModals from "./compModal";
export default {
    mixins: [mixin],
    props: ["activeid", "querytype"],
    components: {
        /* compUpload: () => import("@components/templates/upload"), */
        compMutiUpload: () => import("@components/templates/mutiUpload"),
        compWrapper: () => import("@components/templates/wrapper"),
        compTableList: () => import("@components/templates/tablelist"),
        compModal: () => import("@components/templates/modal"),

        /* compFormQuery: () => import("@components/templates/formquery"),
    compFormEdit: () => import("@components/templates/formedit"),  */
    },
    data() {
        return {
            loading: false,
            startUp: true,
            isPropFile: false,
            tipShow1: false,
            tipShow2: false,
            tipShow5: false,
            datalist: [],
            logList: [],
            opAttachMeta: "",
            attachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            propAttachMetas: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            propDamageProve: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            propGoodsProve: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            attachMetaA: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            attachMetaB: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            attachMetaC: {
                items: [],
                opAt: "",
                organizationId: "",
            },
            attachMetaAll: {
                attachMetaA: {},
                attachMetaB: {},
                attachMetaC: {},
            },
            type: this.$route.params.type,
            id: this.$route.query.id,
            disUse: false,
            trackingShow: false,
            statusName: "",
            operate: {
                show: false,
                title: "附件上传",
                data: {},
            },
            operate2: {
                show: false,
                title: "附件上传",
                data: {},
            },
            operate3: {
                show: false,
                title: "附件上传",
                data: {},
            },
            operate4: {
                show: false,
                title: "附件上传",
                data: {},
            },
            operate5: {
                show: false,
                title: "附件上传",
                data: {},
            },
            operate6: {
                show: false,
                title: "附件上传",
                data: {},
            },
            operate7: {
                show: false,
                title: "附件上传",
                data: {},
            },
            modalProps: {
                show: false,
                loading: false,
                title: "导入数据",
                component: "",
                width: 1000,
                props: {},
                on: {},
            },
            /*  modalProp: {
        title: "附件上传",
        show: false,
        loading: false,
        showFooter: false,
        data: {}
      }, */
            formData: {
                hostOrgId: "",
                contextId: "",
                id: "",
                reimbursementNo: "",
                reimbursementType: "",
                lineId: "",
                status: "",
                reimbursementReason: "",
                sourceNo: "",
                props: "",
                reimbursementAmount: "",
                remark: "",
                attachMeta: "",
            },
            props: {
                trackingType: "",
                erpsku: "",
                qty: "",
                ddp: "",
                warehouseId: "",
                warehouseCode: "",
                warehouseName: "",
                relOrderNo: "",
                trackingNo: "",
                shippingNo: "",
                saleCarrier: "",
                logisticsServiceCode: "",
                returnType: "",
                billType: "",
                saleOrderNo: "",
                returnSaleOrderNo: "",
                returnSaleOrderTrackingNo: "",
                actualErpsku: "",
                actualQty: "",
                actualDdp: "",
                shouldErpsku: "",
                inBoundOrderNo: "",
                packedNo: "",
                fob: "",
                shippingFee: "",
                overdueContainDay: "",
                containFee: "",
                frameFee: "",
                otherFee: "",
                attachMeta: "",
                damageProve: "",
                goodsProve: "",
                isInsurance: 0,
            },
            formDetail: {
                id: "",
                headId: "",
                detailRowKey: "",
                reimbursementAmount: "",
                remark: "",
                detailProps: "",
            },
            detailProps: {
                warehouseId: "",
                warehouseCode: "",
                warehouseName: "",
                costNo: "",
                erpsku: "",
                batchNo: "",
                trackingNo: "",
                dispatchNo: "",
                saleCarrier: "",
                logisticsServiceCode: "",
                qty: "",
                ddp: "",
            },
            saleWarehouse: {},
            searchOptions: {
                reimbursementReason: [],
                returnType: [],
                billType: [],
            },
            needRefresh: true,
            required: [
                {
                    required: true,
                    message: "该信息不能为空,请填写",
                },
            ],
        };
    },
    created() {
        if (this.type === "add") {
            HttpGetBeforeOrgList({}).then((res) => {
                if (res.data.length === 1) {
                    this.$set(this.formData, "hostOrgId", res.data[0].id);
                }
            });
        }
        this.formData.reimbursementType = 1;
        this.searchOptions.reimbursementReason =
            this.reimbursementTypeList.filter((item) => {
                return item.value == this.formData.reimbursementType;
            })[0].child;
        this.formData.reimbursementReason = 1;
        this.getDetail();
    },
    computed: {
        ...mapGetters("dictionary", [
            "getProductList",
            "getWarehouseList",
            "getAllProduct",
            "getAllWareHouseList",
            "getSelfmanageorgList",
            "getSystemWareList",
            "getBeforeOrgList",
            "getOrgList",
        ]),
        getTableListProps() {
            return {
                startUp: this.startUp,
                ajaxRequest: HttpReimbursementDetail,
                initFormData: {
                    "search[EQ_headId]": this.getId,
                },
            };
        },
        getFileProps() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                data: {
                    srcLabel: this.formData.id,
                    model: "logistics",
                    type: "other",
                },
            };
        },
        getFileProps2() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: false,
                data: {
                    srcLabel: this.formData.id,
                    model: "logistics",
                    type: "other",
                },
            };
        },
        getFileProps3() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: false,
                data: {
                    srcLabel: this.formData.id,
                    model: "logistics",
                    type: "other",
                },
            };
        },
        getFileProps4() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: false,
                data: {
                    srcLabel: this.formData.id,
                    model: "logistics",
                    type: "other",
                },
            };
        },
        isQuery() {
            return this.type === "query";
        },
        isAdminQuery() {
            return this.type === "adminQuery";
        },
        getStatus() {
            return this.type !== "add" && this.formData.status;
        },
        getId() {
            return this.formData.id || this.id;
        },
        getBase() {
            const formData = this.formData,
                show = !!this.getId;
            return [
                {
                    label: "索赔单号",
                    key: "reimbursementNo",
                    query: true,
                    show: show,
                },
                {
                    label: "状态",
                    key: "status",
                    query: true,
                    show: show,
                    options: this.statusList,
                },
                {
                    label: "客户",
                    key: "organizationId",
                    query: true,
                    show: this.type === "adminQuery",
                    options: this.getSelfmanageorgList,
                },
                {
                    label: "索赔类型",
                    key: "reimbursementType",
                    query: true,
                    show: show,
                    options: this.reimbursementTypeList,
                },
                {
                    label: "项目",
                    key: "lineId",
                    query: true,
                    show: show,
                    options: this.getAllProduct,
                },
                {
                    label: "索赔原因",
                    key: "reimbursementReason",
                    query: true,
                    show: show,
                    options: this.searchOptions.reimbursementReason,
                },
                {
                    label: "来源单号",
                    key: "sourceNo",
                    query: true,
                    show: show,
                },
                //库内索赔
                {
                    label: "SKU",
                    key: "erpsku",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 1 ||
                        this.formData.reimbursementReason == 13,
                    render: (h) => {
                        return this.props.erpsku;
                    },
                },
                {
                    label: "短少数量",
                    key: "qty",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 1 ||
                        this.formData.reimbursementReason == 13,
                    render: (h) => {
                        return this.props.qty;
                    },
                },
                //头程索赔
                {
                    label: "入库计划单号",
                    key: "inBoundOrderNo",
                    query: true,
                    show: this.formData.reimbursementType == 4,
                    render: (h) => {
                        return this.props.inBoundOrderNo;
                    },
                },
                {
                    label: "集装箱号",
                    key: "packedNo",
                    query: true,
                    show: this.formData.reimbursementType == 4,
                    render: (h) => {
                        return this.props.packedNo;
                    },
                },
                {
                    label: "仓库",
                    key: "warehouseId",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 2 ||
                        this.formData.reimbursementReason == 1 ||
                        this.formData.reimbursementType == 4 ||
                        this.formData.reimbursementReason == 13,
                    //todo
                    render: (h) => {
                        return this.props.warehouseName;
                    },
                },
                {
                    label: "超期用箱工作日",
                    key: "overdueContainDay",
                    query: true,
                    show: this.formData.reimbursementReason == 12,
                    render: (h) => {
                        return this.props.overdueContainDay;
                    },
                },
                {
                    label: "滞箱费(USD)",
                    key: "containFee",
                    query: true,
                    show: this.formData.reimbursementReason == 12,
                    render: (h) => {
                        return this.props.containFee;
                    },
                },
                {
                    label: "车架费(USD)",
                    key: "frameFee",
                    query: true,
                    show: this.formData.reimbursementReason == 12,
                    render: (h) => {
                        return this.props.frameFee;
                    },
                },
                {
                    label: "其他费用(USD)",
                    key: "otherFee",
                    query: true,
                    show: this.formData.reimbursementReason == 12,
                    render: (h) => {
                        return this.props.otherFee;
                    },
                },
                {
                    label: "DDP(USD)",
                    key: "ddp",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 1 ||
                        this.formData.reimbursementReason == 13,
                    render: (h) => {
                        return this.props.ddp;
                    },
                },
                {
                    label: "关联单号",
                    key: "relOrderNo",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 1 ||
                        this.formData.reimbursementReason == 13,
                    render: (h) => {
                        return this.props.relOrderNo;
                    },
                },
                //订单异常平台罚款
                {
                    label: "销售订单号",
                    key: "saleOrderNo",
                    query: true,
                    show: this.formData.reimbursementReason == 2,
                    render: (h) => {
                        return this.props.saleOrderNo;
                    },
                    style: "word-wrap: break-word",
                },
                {
                    label: "管理方",
                    key: "hostOrgId",
                    query: true,
                    show: this.formData.reimbursementType == 3,
                    options: this.getOrgList,
                },
                //仓库发错货 退回-不退回
                {
                    label: "处理方式",
                    key: "returnType",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.searchOptions.returnType.filter((item) => {
                            return item.value == this.props.returnType;
                        })[0].label;
                    },
                },
                {
                    label: "发货订单号",
                    key: "shippingNo",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.shippingNo;
                    },
                },
                {
                    label: "发货仓库",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.warehouseName;
                    },
                },
                {
                    label: "发货Tracking",
                    key: "trackingNo",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.trackingNo;
                    },
                },
                {
                    label: "退货售后单号",
                    key: "returnSaleOrderNo",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 3 &&
                        this.props.returnType == 1,
                    render: (h) => {
                        return this.props.returnSaleOrderNo;
                    },
                },
                {
                    label: "退货Tracking",
                    key: "returnSaleOrderTrackingNo",
                    query: true,
                    show:
                        this.formData.reimbursementReason == 3 &&
                        this.props.returnType == 1,
                    render: (h) => {
                        return this.props.returnSaleOrderTrackingNo;
                    },
                },
                {
                    label: "实发SKU",
                    key: "actualErpsku",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.actualErpsku;
                    },
                },
                {
                    label: "实发数量",
                    key: "actualQty",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.actualQty;
                    },
                },
                {
                    label: "实发SKU DDP(USD)",
                    key: "actualDdp",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.actualDdp;
                    },
                },
                {
                    label: "应发SKU",
                    key: "shouldErpsku",
                    query: true,
                    show: this.formData.reimbursementReason == 3,
                    render: (h) => {
                        return this.props.shouldErpsku;
                    },
                },
                {
                    label: "FOB(USD)",
                    key: "fob",
                    query: true,
                    show:
                        this.formData.reimbursementReason === 1 ||
                        this.formData.reimbursementReason === 3 ||
                        this.formData.reimbursementReason == 13,
                    render: (h) => {
                        return this.props.fob;
                    },
                },
                //尾程
                {
                    label: "Tracking类型",
                    key: "trackingType",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.trackingTypeList.filter((item) => {
                            return item.value == this.props.trackingType;
                        })[0].label;
                    },
                },
                {
                    label: "发货Tracking",
                    key: "trackingNo",
                    query: true,
                    show:
                        this.formData.reimbursementType == 2 &&
                        this.props.trackingType == 1,
                    render: (h) => {
                        return this.props.trackingNo;
                    },
                },
                {
                    label: "退货Tracking",
                    key: "trackingNo",
                    query: true,
                    show:
                        this.formData.reimbursementType == 2 &&
                        this.props.trackingType == 2,
                    render: (h) => {
                        return this.props.trackingNo;
                    },
                },
                {
                    label: "发货订单号",
                    key: "shippingNo",
                    query: true,
                    show:
                        this.formData.reimbursementType == 2 &&
                        this.props.trackingType == 1,
                    render: (h) => {
                        return this.props.shippingNo;
                    },
                },
                {
                    label: "退货订单号",
                    key: "shippingNo",
                    query: true,
                    show:
                        this.formData.reimbursementType == 2 &&
                        this.props.trackingType == 2,
                    render: (h) => {
                        return this.props.shippingNo;
                    },
                },
                {
                    label: "SKU",
                    key: "erpsku",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.props.erpsku;
                    },
                },
                {
                    label: "发货Carrier",
                    key: "saleCarrier",
                    query: true,
                    show:
                        this.formData.reimbursementType == 2 &&
                        this.props.trackingType == 1,
                    render: (h) => {
                        return this.props.saleCarrier;
                    },
                },
                {
                    label: "退货Carrier",
                    key: "saleCarrier",
                    query: true,
                    show:
                        this.formData.reimbursementType == 2 &&
                        this.props.trackingType == 2,
                    render: (h) => {
                        return this.props.saleCarrier;
                    },
                },
                {
                    label: "物流服务",
                    key: "logisticsServiceCode",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.props.logisticsServiceCode;
                    },
                },
                {
                    label: "数量",
                    key: "qty",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.props.qty;
                    },
                },
                {
                    label: "DDP(USD)",
                    key: "ddp",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.props.ddp;
                    },
                },
                {
                    label: "运费",
                    key: "ddp",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.props.shippingFee;
                    },
                },
                {
                    label: "货值证明",
                    key: "propGoodsProve",
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        const extraData = this.props.goodsProve;
                        return extraData
                            ? JSON.parse(extraData).items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /* download={item.attachTitle} href={item.attachUrl} */ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  {
                                                      executor: "download",
                                                      type: "url",
                                                  }
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    label: "破损证明",
                    key: "propDamageProve",
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        const extraData = this.props.damageProve;
                        return extraData
                            ? JSON.parse(extraData).items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /*download={item.attachTitle} href={item.attachUrl}*/ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  {
                                                      executor: "download",
                                                      type: "url",
                                                  }
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    label: "其他证明文件",
                    key: "propAttachMeta",
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        const extraData = this.props.attachMeta;
                        return extraData
                            ? JSON.parse(extraData).items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /* download={item.attachTitle} href={item.attachUrl} */ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  {
                                                      executor: "download",
                                                      type: "url",
                                                  }
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    label: "货值证明",
                    key: "attachMetaA",
                    show: this.formData.reimbursementType == 1,
                    render: (h) => {
                        return this.attachMetaA.items.length !== 0
                            ? this.attachMetaA.items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /* download={item.attachTitle} href={item.attachUrl} */ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  {
                                                      executor: "download",
                                                      type: "url",
                                                  }
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    label: "面单照片",
                    key: "attachMetaB",
                    show: this.formData.reimbursementType == 1,
                    render: (h) => {
                        return this.attachMetaB.items.length !== 0
                            ? this.attachMetaB.items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /* download={item.attachTitle} href={item.attachUrl} */ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  {
                                                      executor: "download",
                                                      type: "url",
                                                  }
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    label: "外箱label照片",
                    key: "attachMetaC",
                    show: this.formData.reimbursementType == 1,
                    render: (h) => {
                        return this.attachMetaC.items.length !== 0
                            ? this.attachMetaC.items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /* download={item.attachTitle} href={item.attachUrl} */ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  {
                                                      executor: "download",
                                                      type: "url",
                                                  }
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    label: "官方投保",
                    key: "isInsurance",
                    query: true,
                    show: this.formData.reimbursementType == 2,
                    render: (h) => {
                        return this.formData.isInsurance == 1 ? "是" : "否";
                    },
                },
                //账单
                {
                    label: "费用类型",
                    key: "billType",
                    query: true,
                    show: this.formData.reimbursementType == 3,
                    render: (h) => {
                        return this.searchOptions.billType.filter((item) => {
                            return item.value == this.props.billType;
                        })[0].label;
                    },
                },
                {
                    label: "账单编号",
                    key: "billNo",
                    query: true,
                    show: this.formData.reimbursementType == 3,
                    render: (h) => {
                        return this.props.billNo;
                    },
                },
                {
                    label: "索赔金额(USD)",
                    key: "reimbursementAmount",
                    query: true,

                    render: (h) => {
                        return this.formData.reimbursementAmount;
                    },
                },
                {
                    label: "caseId",
                    key: "caseId",
                    query: true,
                    show: show,
                },
                {
                    label: "TrackingNo",
                    key: "trackingNo",
                    query: true,
                    show: show,
                },
                {
                    label: "实际发票金额",
                    key: "actualInvoiceAmount",
                    query: true,
                    show: show,
                },
                {
                    label: "CC",
                    key: "sendEmail",
                    required: false,
                },
                {
                    label: "备注",
                    tag: "vTextarea",
                    key: "remark",
                    required: false,
                },
                {
                    label: "附件",
                    key: "attachMeta",
                    show:
                        this.formData.reimbursementType === 3 ||
                        this.formData.reimbursementType === 4,
                    render: (h) => {
                        if (this.formData.attachMeta) {
                            const extraData = JSON.parse(
                                this.formData.attachMeta
                            );
                            return extraData
                                ? extraData.items.map((item) => {
                                      return (
                                          <span
                                              class="margin-right-20"
                                              style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400"
                                          >
                                              <Tooltip
                                                  placement="top"
                                                  max-width="80px"
                                              >
                                                  <div slot="content">
                                                      {item.attachTitle || "-"}
                                                  </div>
                                                  <a
                                                      onClick={this.handleWebfs.bind(
                                                          this,
                                                          item.attachUrl,
                                                          {},
                                                          "download"
                                                      )}
                                                  >
                                                      {item.attachTitle.length >
                                                      20
                                                          ? item.attachTitle
                                                                .slice(0, 20)
                                                                .concat("...")
                                                          : item.attachTitle ||
                                                            "-"}
                                                  </a>
                                              </Tooltip>
                                          </span>
                                      );
                                  })
                                : "-";
                        }
                    },
                },
            ];
        },
        getInColumnsInv() {
            //库内费用-仓储费
            if (
                this.props.billType == 2 &&
                this.formData.reimbursementReason == 9
            ) {
                return [
                    {
                        type: "selection",
                        width:
                            this.type === "query" || this.type === "adminQuery"
                                ? 0
                                : 40,
                        align: "left",
                        formName: "id",
                    },
                    {
                        title: "NO.",
                        type: "index",
                        width: 50,
                        align: "left",
                    },
                    {
                        title: "SKU",
                        width: 140,
                        key: "detailRowKey",
                        align: "left",
                    },
                    {
                        title: "批次号",
                        width: 140,
                        key: "batchNo",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).batchNo;
                        },
                    },
                    {
                        title: "仓库",
                        width: 140,
                        key: "warehouseName",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).warehouseName;
                        },
                    },
                    {
                        title: "索赔金额(USD)",
                        width: 140,
                        key: "reimbursementAmount",
                        align: "left",
                    },
                    {
                        title: "备注",
                        key: "remark",
                        align: "left",
                    },
                ];
            } else if (this.formData.reimbursementReason == 10) {
                return [
                    {
                        type: "selection",
                        width:
                            this.type === "query" || this.type === "adminQuery"
                                ? 0
                                : 40,
                        align: "left",
                        formName: "id",
                    },
                    {
                        title: "NO.",
                        type: "index",
                        width: 50,
                        align: "left",
                    },
                    {
                        title: "Tracking",
                        width: 120,
                        key: "detailRowKey",
                        align: "left",
                    },
                    {
                        title: "订单号",
                        width: 120,
                        key: "dispatchNo",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).dispatchNo;
                        },
                    },
                    {
                        title: "Carrier",
                        width: 120,
                        key: "saleCarrier",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).saleCarrier;
                        },
                    },
                    {
                        title: "SKU",
                        width: 120,
                        key: "erpsku",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).erpsku;
                        },
                    },
                    {
                        title: "仓库",
                        width: 120,
                        key: "warehouseName",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).warehouseName;
                        },
                    },
                    {
                        title: "索赔金额(USD)",
                        width: 100,
                        key: "reimbursementAmount",
                        align: "left",
                    },
                    {
                        title: "备注",
                        key: "remark",
                        align: "left",
                    },
                ];
            } else if (this.formData.reimbursementReason == 11) {
                return [
                    {
                        type: "selection",
                        width:
                            this.type === "query" || this.type === "adminQuery"
                                ? 0
                                : 40,
                        align: "left",
                        formName: "id",
                    },
                    {
                        title: "NO.",
                        type: "index",
                        width: 50,
                        align: "left",
                    },
                    {
                        title: "SKU",
                        width: 120,
                        key: "detailRowKey",
                        align: "left",
                    },
                    {
                        title: "短少数量",
                        width: 120,
                        key: "qty",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).qty;
                        },
                    },
                    {
                        title: "DDP(USD)",
                        width: 120,
                        key: "ddp",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).ddp;
                        },
                    },
                    {
                        title: "索赔金额(USD)",
                        width: 100,
                        key: "reimbursementAmount",
                        align: "left",
                    },
                    {
                        title: "备注",
                        key: "remark",
                        align: "left",
                    },
                ];
            } else {
                return [
                    {
                        type: "selection",
                        width:
                            this.type === "query" || this.type === "adminQuery"
                                ? 0
                                : 40,
                        align: "left",
                        formName: "id",
                    },
                    {
                        title: "NO.",
                        type: "index",
                        width: 50,
                        align: "left",
                    },
                    {
                        title: "计费单号/关联单据号",
                        width: 170,
                        key: "detailRowKey",
                        align: "left",
                    },
                    {
                        title: "仓库",
                        width: 170,
                        key: "warehouseName",
                        align: "left",
                        render: (h, { row }) => {
                            return JSON.parse(row.detailProps).warehouseName;
                        },
                    },
                    {
                        title: "索赔金额(USD)",
                        width: 170,
                        key: "reimbursementAmount",
                        align: "left",
                    },
                    {
                        title: "备注",
                        key: "remark",
                        align: "left",
                    },
                ];
            }
        },
        getLogColumns() {
            return [
                {
                    title: "NO.",
                    type: "index",
                    width: 60,
                    align: "left",
                },
                {
                    title: "操作类型",
                    key: "opAction",
                    width: 120,
                    align: "left",
                },
                {
                    title: "操作人",
                    key: "opUserName",
                    width: 120,
                    align: "left",
                },
                {
                    title: "附件",
                    key: "opAttachMeta",
                    width: 300,
                    align: "left",
                    render(h, { row }) {
                        const extraData = row.opAttachMeta;
                        return extraData
                            ? JSON.parse(extraData).items.map((item) => {
                                  return (
                                      <div>
                                          <a
                                              /* download={item.attachTitle} href={item.attachUrl} */ onClick={this.handleWebfs.bind(
                                                  this,
                                                  item.attachUrl,
                                                  {},
                                                  "download"
                                              )}
                                          >
                                              {item.attachTitle || "-"}
                                          </a>
                                      </div>
                                  );
                              })
                            : "-";
                    },
                },
                {
                    title: "备注",
                    key: "opData",
                    width: 300,
                    align: "left",
                },
                {
                    title: "操作时间",
                    key: "opAt",
                    align: "left",
                },
            ];
        },
        getStatusBtns() {
            const getStatus = this.getStatus;
            const btn = [
                {
                    name: "提交审核",
                    show:
                        getStatus == 1 ||
                        (getStatus == 3 && this.type === "query"),
                    theme: "primary",
                    run: this.toAudit,
                },
                {
                    name: "撤销审核",
                    show: getStatus == 2 && this.type === "query",
                    theme: "warning",
                    run: this.cancelAudit,
                },
                {
                    name: "审核",
                    show: getStatus == 2 && this.type === "adminQuery",
                    theme: "success",
                    run: this.audit,
                },
                {
                    name: "添加备注",
                    show: getStatus == 4 && this.type === "adminQuery",
                    theme: "primary",
                    run: this.addRemark,
                },
                {
                    name: "取消",
                    show: getStatus == 1 || getStatus == 2 || getStatus == 3,
                    theme: "error",
                    run: this.cancelReimbursement,
                },
                {
                    name: "调账",
                    show: getStatus == 4 && this.type === "adminQuery",
                    theme: "info",
                    run: this.checkBill,
                },
                {
                    name: "完成",
                    show: getStatus == 4 && this.type === "adminQuery",
                    theme: "success",
                    run: this.complete,
                },
                {
                    name: "返回",
                    show: true,
                    run: this.close,
                },
            ];
            return btn.filter((item) => item.show);
        },
    },
    watch: {
        // 方法1
        $route: function (to, from) {
            //监听路由是否变化
            HttpReimbursementGetById(this.formData).then(
                (res) => {
                    this.formData.reimbursementNo =
                        res.data.reimbursementEntity.reimbursementNo;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        "props.warehouseId": {
            immediate: true,
            handler(warehouseId) {
                if (!warehouseId) return;
                this.getHostId();
            },
        },
    },
    methods: {
        async handleAmount() {
            if (this.formData.reimbursementType === 2) {
                this.formData.reimbursementAmount =
                    this.props.ddp + this.props.shippingFee;
            }
        },
        downloadPackageLabel() {
            this.handleWebfs(
                HttpExportClaimStatement,
                { id: this.id },
                { executor: "request", download: true }
            );
        },
        refreshPage() {
            this.needRefresh = false;

            this.update();
        },
        update(needClose) {
            /* if (needClose) {
        this.operate.show = false;
      } */
            if (this.querytype) {
                this.id = this.activeid;
                this.type = this.querytype;
            } else {
                this.id = this.$route.query.id;
                this.type = this.type;
            }
            this.getDetail();
        },
        getHostId() {
            HttpHosWarehouse({
                orgWarehouseId: this.props.warehouseId,
            }).then((res) => {
                this.formData.hostOrgId = res.data.hostOrgId;
            });
        },
        changerewarehouse() {
            this.props.warehouseCode = this.getWarehouseList.filter((item) => {
                return item.value == this.props.warehouseId;
            })[0].attach.code;
            this.props.warehouseName = this.getWarehouseList.filter((item) => {
                return item.value == this.props.warehouseId;
            })[0].label;
        },
        changeDetailWarehouse() {
            console.log(this.detailProps);
            this.detailProps.warehouseCode = this.getWarehouseList.filter(
                (item) => {
                    return item.value == this.detailProps.warehouseId;
                }
            )[0].attach.code;

            this.detailProps.warehouseName = this.getWarehouseList.filter(
                (item) => {
                    return item.value == this.detailProps.warehouseId;
                }
            )[0].label;
            console.log(this.detailProps);
        },
        changebursementType() {
            this.searchOptions.reimbursementReason =
                this.reimbursementTypeList.filter((item) => {
                    return item.value == this.formData.reimbursementType;
                })[0].child;
            /* 库内索赔 */
            if (this.formData.reimbursementType == 1) {
                this.formData.reimbursementReason = 1;
            } else if (this.formData.reimbursementType == 2) {
                this.formData.reimbursementReason = 4;
                this.props.trackingType = 1;
            } else if (this.formData.reimbursementType == 3) {
                this.formData.reimbursementReason = 9;
                this.searchOptions.billType =
                    this.searchOptions.reimbursementReason.filter((item) => {
                        return item.value == this.formData.reimbursementReason;
                    })[0].child;
                this.props.billType = 1;
            } else if (this.formData.reimbursementType == 4) {
                this.formData.reimbursementReason = 11;
            }
            this.props.fob = "";
            this.formData.reimbursementAmount = "";
        },
        //验证集装箱号
        changePackNo() {
            const test1 = /^[A-Z]+$/;
            const test2 = /^[0-9]*$/;
            if (this.props.packedNo) {
                if (this.props.packedNo.length !== 11) {
                    this.$VMessage.error("集装箱号有误");
                } else {
                    const latter = this.props.packedNo.substr(0, 4);
                    const no = this.props.packedNo.substr(4, 7);
                    if (test1.test(latter)) {
                        if (!test2.test(no)) {
                            this.$VMessage.error("集装箱号格式有误");
                        }
                    } else {
                        this.$VMessage.error("集装箱号格式有误");
                    }
                }
            }
        },
        changereimbursementReason() {
            if (
                this.formData.reimbursementType == 1 &&
                this.formData.reimbursementReason == 3
            ) {
                this.searchOptions.returnType =
                    this.searchOptions.reimbursementReason.filter((item) => {
                        return item.value == this.formData.reimbursementReason;
                    })[0].child;
                this.props.returnType = 1;
            } else if (
                this.formData.reimbursementType == 3 &&
                this.formData.reimbursementReason == 9
            ) {
                this.searchOptions.billType =
                    this.searchOptions.reimbursementReason.filter((item) => {
                        return item.value == this.formData.reimbursementReason;
                    })[0].child;
                this.props.billType = 1;
            } else if (
                this.formData.reimbursementType == 3 &&
                this.formData.reimbursementReason == 10
            ) {
                this.searchOptions.billType =
                    this.searchOptions.reimbursementReason.filter((item) => {
                        return item.value == this.formData.reimbursementReason;
                    })[0].child;
                this.props.billType = 5;
            }
            this.props.fob = "";
            this.formData.reimbursementAmount = "";
        },

        importFile() {
            this.isPropFile = false;
            this.operate.show = true;
        },
        importPropFile() {
            this.isPropFile = true;
            this.operate2.show = true;
        },
        importPropFile1() {
            this.operate3.show = true;
        },
        importPropFile2() {
            this.operate4.show = true;
        },
        importPropFile5() {
            this.operate5.show = true;
        },
        importPropFile6() {
            this.operate6.show = true;
        },
        importPropFile7() {
            this.operate7.show = true;
        },
        aaasuccess(res) {
            // 检查文件大小，如果超过限制则直接终止方法
            for (const item of res.originData) {
                if (item.entity.fileSize > 4194304) {
                    this.$VMessage.error(
                        "上传文件名：" +
                            item.entity.filename +
                            "，文件大小不能超过4M!"
                    );
                    this.cancelUpload(); // 取消上传操作
                    return; // 直接跳出整个方法
                }
            }
            const ajaxRequest = this.isPropFile
                ? HttpAddPropAttach
                : HttpAddRelAttach;
            if (this.isPropFile) {
                res.items.forEach((item) => {
                    this.propAttachMetas.items.push(item);
                });
                this.propAttachMetas.opAt = res.opAt;
                this.propAttachMetas.organizationId = res.organizationId;
            } else {
                res.items.forEach((item) => {
                    this.attachMetas.items.push(item);
                });
                this.attachMetas.opAt = res.opAt;
                this.attachMetas.organizationId = res.organizationId;
            }
            if (this.type === "edit") {
                ajaxRequest({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachMeta: this.isPropFile
                        ? JSON.stringify(this.propAttachMetas)
                        : JSON.stringify(this.attachMetas),
                }).then();
            }
            this.cancelUpload();
        },
        aaasuccess3(res) {
            // 检查文件大小，如果超过限制则直接终止方法
            for (const item of res.originData) {
                if (item.entity.fileSize > 4194304) {
                    this.$VMessage.error(
                        "上传文件名：" +
                            item.entity.filename +
                            "，文件大小不能超过4M!"
                    );
                    this.cancelUpload(); // 取消上传操作
                    return; // 直接跳出整个方法
                }
            }
            const ajaxRequest = HttpAddPropAttach;
            res.items.forEach((item) => {
                this.propGoodsProve.items.push(item);
            });
            this.propGoodsProve.opAt = res.opAt;
            this.propGoodsProve.organizationId = res.organizationId;
            this.tipShow1 = false;
            if (this.type === "edit") {
                ajaxRequest({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachMeta: JSON.stringify(this.propGoodsProve),
                }).then();
            }
            this.cancelUpload();
        },
        aaasuccess4(res) {
            // 检查文件大小，如果超过限制则直接终止方法
            for (const item of res.originData) {
                if (item.entity.fileSize > 4194304) {
                    this.$VMessage.error(
                        "上传文件名：" +
                            item.entity.filename +
                            "，文件大小不能超过4M!"
                    );
                    this.cancelUpload(); // 取消上传操作
                    return; // 直接跳出整个方法
                }
            }
            const ajaxRequest = HttpAddPropAttach;
            res.items.forEach((item) => {
                this.propDamageProve.items.push(item);
            });
            this.propDamageProve.opAt = res.opAt;
            this.propDamageProve.organizationId = res.organizationId;
            this.tipShow2 = false;
            if (this.type === "edit") {
                ajaxRequest({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachMeta: JSON.stringify(this.propDamageProve),
                }).then((err) => {
                    this.$VMessage.error(err.message);
                });
            }
            this.cancelUpload();
        },
        aaasuccess5(res) {
            if (res) {
                // 检查文件大小，如果超过限制则直接终止方法
                for (const item of res.originData) {
                    if (item.entity.fileSize > 4194304) {
                        this.$VMessage.error(
                            "上传文件名：" +
                                item.entity.filename +
                                "，文件大小不能超过4M!"
                        );
                        this.cancelUpload(); // 取消上传操作
                        return; // 直接跳出整个方法
                    }
                }
                // 以下代码仅在文件大小全部合规时执行
                res.items.forEach((item) => {
                    this.attachMetaA.items.push(item);
                });
                this.attachMetaA.opAt = res.opAt;
                this.attachMetaA.organizationId = res.organizationId;
                this.tipShow5 = false;
            }
            this.cancelUpload();
        },
        aaasuccess6(res) {
            if (res) {
                // 检查文件大小，如果超过限制则直接终止方法
                for (const item of res.originData) {
                    if (item.entity.fileSize > 4194304) {
                        this.$VMessage.error(
                            "上传文件名：" +
                                item.entity.filename +
                                "，文件大小不能超过4M!"
                        );
                        this.cancelUpload(); // 取消上传操作
                        return; // 直接跳出整个方法
                    }
                }
                res.items.forEach((item) => {
                    this.attachMetaB.items.push(item);
                });
                this.attachMetaB.opAt = res.opAt;
                this.attachMetaB.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },
        aaasuccess7(res) {
            if (res) {
                // 检查文件大小，如果超过限制则直接终止方法
                for (const item of res.originData) {
                    if (item.entity.fileSize > 4194304) {
                        this.$VMessage.error(
                            "上传文件名：" +
                                item.entity.filename +
                                "，文件大小不能超过4M!"
                        );
                        this.cancelUpload(); // 取消上传操作
                        return; // 直接跳出整个方法
                    }
                }
                res.items.forEach((item) => {
                    this.attachMetaC.items.push(item);
                });
                this.attachMetaC.opAt = res.opAt;
                this.attachMetaC.organizationId = res.organizationId;
            }
            this.cancelUpload();
        },

        clearUpload(index) {
            if (this.type === "add") {
                HttpDelFile({
                    contextId: global.SYSID,
                    id: this.attachMetas.items[index].attachId,
                }).then(
                    (res) => {
                        this.attachMetas.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            } else if (this.type === "edit") {
                HttpDelRelAttach({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachId: this.attachMetas.items[index].attachId,
                }).then(
                    (res) => {
                        this.attachMetas.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        //尾程其他证明文件
        clearPropUpload(index) {
            if (this.type === "add") {
                HttpDelFile({
                    contextId: global.SYSID,
                    id: this.propAttachMetas.items[index].attachId,
                }).then(
                    (res) => {
                        this.propAttachMetas.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            } else if (this.type === "edit") {
                HttpDelPropAttach({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachId: this.propAttachMetas.items[index].attachId,
                }).then(
                    (res) => {
                        this.propAttachMetas.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        //尾程货值证明
        clearPropUpload3(index) {
            if (this.type === "add") {
                HttpDelFile({
                    contextId: global.SYSID,
                    id: this.propGoodsProve.items[index].attachId,
                }).then(
                    (res) => {
                        this.propGoodsProve.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            } else if (this.type === "edit") {
                HttpDelPropAttach({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachId: this.propGoodsProve.items[index].attachId,
                }).then(
                    (res) => {
                        this.propGoodsProve.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        //尾程破损证明
        clearPropUpload4(index) {
            if (this.type === "add") {
                HttpDelFile({
                    contextId: global.SYSID,
                    id: this.propDamageProve.items[index].attachId,
                }).then(
                    (res) => {
                        this.propDamageProve.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            } else if (this.type === "edit") {
                HttpDelPropAttach({
                    contextId: global.SYSID,
                    id: this.formData.id,
                    attachId: this.propDamageProve.items[index].attachId,
                }).then(
                    (res) => {
                        this.propDamageProve.items.splice(index, 1);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        //库内索赔货值证明
        clearPropUpload5(index) {
            this.attachMetaA.items.splice(index, 1);
            window.console.log("this.attachMetaA", this.attachMetaA);
        },
        //库内索赔面单照片
        clearPropUpload6(index) {
            this.attachMetaB.items.splice(index, 1);
        },
        //库内索赔面单照片
        clearPropUpload7(index) {
            this.attachMetaC.items.splice(index, 1);
        },
        cancelUpload() {
            this.operate.show = false;
            this.operate2.show = false;
            this.operate3.show = false;
            this.operate4.show = false;
            this.operate5.show = false;
            this.operate6.show = false;
            this.operate7.show = false;
        },
        cancel() {
            this.$router.push({ name: "reimbursement" });
            this.loading = false;
        },
        //提交
        async submit(Status) {
            const valid = await this.$refs.editform.validate();
            if (!valid) return;
            this.loading = true;
            var flag1 = false;
            var mes = "";
            if (Status == 2) {
                if (
                    this.formData.id &&
                    (this.formData.reimbursementType === 3 ||
                        this.formData.reimbursementReason === 11)
                ) {
                    await HttpReimbursementDetail({
                        search: {
                            EQ_headId: this.formData.id,
                        },
                        rows: 1000,
                    }).then(
                        (res) => {
                            if (res.data.content.length == 0) {
                                mes = "索赔明细为空，无法提交审核";
                                flag1 = true;

                                return;
                            }
                        },
                        (err) => {
                            this.loading = false;
                            this.$VMessage.error(err.message);
                        }
                    );
                }
            }

            if (flag1) {
                this.loading = false;
                this.$VMessage.error(mes);
                return;
            }
            //库存短少验证
            let flag = false;
            if (this.formData.reimbursementReason == 1) {
                //验证SKU
                /*  await HttpFindBySku({
          contextId: global.SYSID,
          erpSku: this.props.erpsku
        }).then(
          res => {
            if (!res.data) {
              flag = true;
            }
          },
          errerr => {
            this.loading = false;
            this.$VMessage.error(err.message);
          }
        );
        if (flag) {
          this.loading = false;
          this.$VMessage.error("当前组织下无该SKU");
          return;
        } */
                //验证短少数量
                const r = /^\+?[1-9][0-9]*$/;
                if (!r.test(Number(this.props.qty))) {
                    this.loading = false;
                    this.$VMessage.error("短少数量必须大于0的整数");
                    return;
                }
                if (Number(this.props.ddp) <= 0) {
                    this.loading = false;
                    this.$VMessage.error("DDP(USD)必须大于0的数值");
                    return;
                }
            }
            if (this.formData.reimbursementReason == 3) {
                // if(this.props.actualErpsku){
                //   //验证SKU
                //   await HttpFindBySku({
                //     contextId: global.SYSID,
                //     erpSku: this.props.actualErpsku
                //   }).then(
                //     res => {
                //       if (!res.data) {
                //         flag = true;
                //       }
                //     },
                //     err => {
                //       this.loading = false;
                //       this.$VMessage.error(err.message);
                //     }
                //   );
                //   if (flag) {
                //     this.loading = false;
                //     this.$VMessage.error("当前组织下无该实发SKU");
                //     return;
                //   }
                // }

                //验证短少数量
                const r = /^\+?[1-9][0-9]*$/;
                if (!r.test(Number(this.props.actualQty))) {
                    this.loading = false;
                    this.$VMessage.error("实发数量必须大于0的整数");
                    return;
                }
                // if (Number(this.props.actualDdp) <= 0) {
                //   this.loading = false;
                //   this.$VMessage.error("实发SKU DDP(USD)必须大于0的数值");
                //   return;
                // }
            }
            //库内索赔
            if (this.formData.reimbursementType == 1) {
                this.attachMetaAll.attachMetaA = this.attachMetaA;
                window.console.log(
                    "this.attachMetaAll.attachMetaA",
                    this.attachMetaAll.attachMetaA
                );
                this.attachMetaAll.attachMetaB = this.attachMetaB;
                this.attachMetaAll.attachMetaC = this.attachMetaC;
                this.formData.attachMeta = JSON.stringify(this.attachMetaAll);
                window.console.log(
                    "this.formData.attachMeta",
                    this.formData.attachMeta
                );
            }
            //尾程索赔
            if (this.formData.reimbursementType == 2) {
                this.props.attachMeta = JSON.stringify(this.propAttachMetas);
                this.props.damageProve = JSON.stringify(this.propDamageProve);
                this.props.goodsProve = JSON.stringify(this.propGoodsProve);
                if (
                    this.propDamageProve.items.length === 0 &&
                    this.formData.reimbursementReason === 6
                ) {
                    this.tipShow2 = true;
                    this.loading = false;
                    return;
                }
                if (this.propGoodsProve.items.length === 0) {
                    this.tipShow1 = true;
                    this.loading = false;
                    return;
                }
                console.log(this.props.attachMeta);
                // //验证SKU
                // if (this.trackingShow == false) {
                //     await HttpFindBySku({
                //         contextId: global.SYSID,
                //         erpSku: this.props.erpsku,
                //     }).then(
                //         (res) => {
                //             if (!res.data) {
                //                 flag = true;
                //             }
                //         },
                //         (err) => {
                //             this.loading = false;
                //             this.$VMessage.error(err.message);
                //         }
                //     );
                //     if (flag) {
                //         this.loading = false;
                //         this.$VMessage.error("当前组织下无该SKU");
                //         return;
                //     }
                // }
                //验证数量
                const r = /^\+?[1-9][0-9]*$/;
                if (!r.test(Number(this.props.qty))) {
                    this.loading = false;
                    this.$VMessage.error("数量必须大于0的整数");
                    return;
                }
                if (Number(this.props.ddp) <= 0) {
                    this.loading = false;
                    this.$VMessage.error("DDP(USD)必须大于0的数值");
                    return;
                }
            }
            if (this.formData.reimbursementType == 4) {
                if (!this.props.warehouseName) {
                    this.$VMessage.error("仓库不能为空");
                    this.loading = false;
                    return;
                }
                const test1 = /^[A-Z]+$/;
                const test2 = /^[0-9]*$/;
                if (this.props.packedNo) {
                    if (this.props.packedNo.length !== 11) {
                        this.loading = false;
                        this.$VMessage.error("集装箱号有误");
                        return;
                    } else {
                        const latter = this.props.packedNo.substr(0, 4);
                        const no = this.props.packedNo.substr(4, 7);
                        if (test1.test(latter)) {
                            if (!test2.test(no)) {
                                this.loading = false;
                                this.$VMessage.error("集装箱号格式有误");
                                return;
                            }
                        } else {
                            this.loading = false;
                            this.$VMessage.error("集装箱号格式有误");
                            return;
                        }
                    }
                }
                const arr = this.props.inBoundOrderNo.split(",");
                console.log(arr);
                for (var i = 0; i < arr.length; i++) {
                    console.log(arr[i]);
                    const inNo = arr[i];
                    HttpInboundPlanCheck({
                        contextId: global.SYSID,
                        inboundPlanOrderNo: arr[i],
                    }).then((res) => {
                        if (!res.data) {
                            this.$VMessage.error(
                                "入库计划单:" + inNo + "不在该组织下！"
                            );
                            this.loading = false;
                            return;
                        }
                    });
                }
            }
            if (Number(this.formData.reimbursementAmount) <= 0) {
                this.loading = false;
                this.$VMessage.error("索赔金额必须大于0的数值");
                return;
            }
            /*  this.formData.sourceNo = this.formData.sourceNo.replace(/(^\s*)|(\s*$)/g, "");
      this.props.trackingNo = this.props.trackingNo.replace(/(^\s*)|(\s*$)/g, "");
      this.props.saleCarrier = this.props.saleCarrier.replace(/(^\s*)|(\s*$)/g, ""); */
            this.formData.props = JSON.stringify(this.props);
            if (this.formData.reimbursementType != 1) {
                this.formData.attachMeta = JSON.stringify(this.attachMetas);
            }
            this.formData.status = Status;
            HttpReimbursementSave({ ...this.formData }).then(
                (res) => {
                    this.cancel();
                    this.$VMessage.success(res.message);
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        getStatusName() {
            return this.statusList.filter((item) => {
                return item.value == this.formData.status;
            })[0].label;
        },
        //下一步
        async next() {
            const valid = await this.$refs.editform.validate();
            if (!valid) return;
            this.loading = true;
            if (Number(this.formData.reimbursementAmount) <= 0) {
                this.$VMessage.error("索赔金额必须大于0的数值");
                this.loading = false;
                return;
            }
            if (this.formData.reimbursementReason === 11) {
                if (!this.props.warehouseName) {
                    this.$VMessage.error("仓库不能为空");
                    this.loading = false;
                    return;
                }
                const test1 = /^[A-Z]+$/;
                const test2 = /^[0-9]*$/;
                if (this.props.packedNo) {
                    if (this.props.packedNo.length !== 11) {
                        this.loading = false;
                        this.$VMessage.error("集装箱号有误");
                        return;
                    } else {
                        const latter = this.props.packedNo.substr(0, 4);
                        const no = this.props.packedNo.substr(4, 7);
                        if (test1.test(latter)) {
                            if (!test2.test(no)) {
                                this.loading = false;
                                this.$VMessage.error("集装箱号格式有误");
                                return;
                            }
                        } else {
                            this.loading = false;
                            this.$VMessage.error("集装箱号格式有误");
                            return;
                        }
                    }
                }
                const arr = this.props.inBoundOrderNo.split(",");
                console.log(arr);
                for (var i = 0; i < arr.length; i++) {
                    console.log(arr[i]);
                    const inNo = arr[i];
                    HttpInboundPlanCheck({
                        contextId: global.SYSID,
                        inboundPlanOrderNo: arr[i],
                    }).then((res) => {
                        if (!res.data) {
                            this.$VMessage.error(
                                "入库计划单:" + inNo + "不在该组织下！"
                            );
                            this.loading = false;
                            return;
                        }
                    });
                }
            }
            this.formData.status = 1;
            this.statusName = this.getStatusName();
            // 提交当前页面的内容

            this.disUse = true;
            /*  this.formData.sourceNo = this.formData.sourceNo.replace(/(^\s*)|(\s*$)/g, ""); */

            this.formData.props = JSON.stringify(this.props);
            this.formData.attachMeta = JSON.stringify(this.attachMetas);
            console.log(this.formData);
            HttpReimbursementSave({
                contextId: global.SYSID,
                ...this.formData,
            }).then(
                (res) => {
                    this.type = "edit";
                    // 跳转到相对应页面
                    this.$router.push({
                        name: "reimbursementUpdate",
                        params: { type: "edit" },
                        query: { id: res.data.id },
                    });
                    this.formData.id = res.data.id;
                    this.loading = false;
                },
                (err) => {
                    this.disUse = false;
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        async addItem() {
            const valid = await this.$refs.detailform.validate();
            if (!valid) return;
            let flag = false;
            if (
                this.formData.reimbursementReason === 9 &&
                this.props.billType === 2
            ) {
                //验证SKU
                await HttpFindBySku({
                    contextId: global.SYSID,
                    erpSku: this.detailProps.erpsku,
                }).then(
                    (res) => {
                        if (!res.data) {
                            flag = true;
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
                if (flag) {
                    this.$VMessage.error("当前组织下无该SKU");
                    return;
                }
            }
            if (
                this.formData.reimbursementReason === 10 ||
                this.formData.reimbursementReason === 11
            ) {
                if (this.detailProps.erpsku) {
                    await HttpFindBySku({
                        contextId: global.SYSID,
                        erpSku: this.detailProps.erpsku,
                    }).then(
                        (res) => {
                            if (!res.data) {
                                flag = true;
                            }
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                    if (flag) {
                        this.$VMessage.error("当前组织下无该SKU");
                        return;
                    }
                }
                //验证SKU
            }
            if (Number(this.formDetail.reimbursementAmount) <= 0) {
                this.$VMessage.error("索赔金额必须大于0的数值");
                return;
            }

            //仓储费
            if (
                this.formData.reimbursementReason == 9 &&
                this.props.billType == 2
            ) {
                this.formDetail.detailRowKey = this.detailProps.erpsku;
            } else if (this.formData.reimbursementReason == 10) {
                this.formDetail.detailRowKey = this.detailProps.trackingNo;
            } else if (this.formData.reimbursementReason == 11) {
                this.formDetail.detailRowKey = this.detailProps.erpsku;
            } else {
                this.formDetail.detailRowKey = this.detailProps.costNo;
            }
            this.formDetail.headId = this.formData.id;
            this.formDetail.detailProps = JSON.stringify(this.detailProps);
            HttpReimbursementDetatilSave({
                contextId: global.SYSID,
                ...this.formDetail,
            }).then(
                (res) => {
                    /* this.loading = false;
          this.getDetail(); */
                    this.startUp += 1;
                    this.formDetail.reimbursementAmount = "";
                    this.formDetail.remark = "";
                    this.detailProps.costNo = "";
                    this.detailProps.erpsku = "";
                    this.detailProps.batchNo = "";
                    this.detailProps.trackingNo = "";
                    this.detailProps.dispatchNo = "";
                    this.detailProps.saleCarrier = "";
                    this.detailProps.qty = "";
                    this.detailProps.ddp = "";
                    /*  for(var i=0;i<this.getWarehouseList.length;i++){
this.getWarehouseList.options[i].selected = false;
} */

                    /*   for (var key in this.detailProps) {
            delete this.detailProps[key];
          }
          for (var keys in this.formDetail) {
            delete this.formDetail[keys];
          } */
                    HttpReimbursementDetail({
                        search: {
                            EQ_headId: this.formData.id,
                        },
                        rows: 1000,
                    }).then(
                        (res) => {
                            let sum = 0;
                            res.data.content.forEach((item) => {
                                //遍历reimbursementAmount这个字段，并累加
                                sum += item.reimbursementAmount;
                            });
                            this.formData.reimbursementAmount = sum;
                            //保存头单据
                            HttpReimbursementSave({ ...this.formData });
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getDetail() {
            if (this.querytype) {
                this.id = this.activeid;
                this.type = this.querytype;
            } else {
                this.id = this.$route.query.id;
                this.type = this.type;
            }

            if (!this.getId) return;
            this.loading = true;
            HttpReimbursementGetById({
                id: this.getId,
            }).then(
                (res) => {
                    this.disUse = true;
                    this.handleResponse(res.data);
                    this.$nextTick(() => {
                        this.needRefresh = true;
                    });
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        getReimbursementDetail() {
            HttpReimbursementDetail({
                "search[EQ_headId]": this.id,
                page: 1,
                rows: 1000,
            }).then(
                (res) => {
                    this.datalist = res.data.content;
                    this.loading = false;
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleResponse(data) {
            this.formData = data.reimbursementEntity;
            this.getReimbursementDetail();
            if (this.formData.props) {
                this.props = JSON.parse(this.formData.props);
                if (this.formData.reimbursementType == 2) {
                    if (this.props.erpsku) {
                        this.trackingShow = false;
                    } else {
                        this.trackingShow = true;
                    }
                }
            }

            if (
                this.formData.attachMeta &&
                this.formData.reimbursementType != 1
            ) {
                this.attachMetas = JSON.parse(this.formData.attachMeta);
            }

            this.searchOptions.reimbursementReason =
                this.reimbursementTypeList.filter((item) => {
                    return item.value == this.formData.reimbursementType;
                })[0].child;

            console.log(this.searchOptions.reimbursementReason);
            this.searchOptions.returnType =
                this.searchOptions.reimbursementReason.filter((item) => {
                    return item.value == this.formData.reimbursementReason;
                })[0].child;
            console.log(this.searchOptions.returnType);
            this.props.returnType = this.props.returnType;
            this.searchOptions.billType =
                this.searchOptions.reimbursementReason.filter((item) => {
                    return item.value == this.formData.reimbursementReason;
                })[0].child;
            console.log(this.searchOptions.billType);
            this.props.billType = this.props.billType;

            this.logList = data.orderLogEntities.reverse() || [];
            this.statusName = this.getStatusName();
            if (this.formData.reimbursementType == 2) {
                if (this.props.attachMeta) {
                    if (JSON.parse(this.props.attachMeta).items.length !== 0) {
                        console.log(JSON.parse(this.props.attachMeta).items);
                        this.propAttachMetas = JSON.parse(
                            this.props.attachMeta
                        );
                    }
                }
                if (this.props.damageProve) {
                    if (JSON.parse(this.props.damageProve).items.length !== 0) {
                        this.propDamageProve = JSON.parse(
                            this.props.damageProve
                        );
                    }
                }
                if (this.props.goodsProve) {
                    if (JSON.parse(this.props.goodsProve).items.length !== 0) {
                        this.propGoodsProve = JSON.parse(this.props.goodsProve);
                    }
                }
            }
            if (this.formData.reimbursementType == 1) {
                if (this.formData.attachMeta) {
                    this.attachMetaAll = JSON.parse(this.formData.attachMeta);
                    const jsonStringA = JSON.stringify(
                        this.attachMetaAll.attachMetaA
                    );
                    const jsonStringB = JSON.stringify(
                        this.attachMetaAll.attachMetaB
                    );
                    const jsonStringC = JSON.stringify(
                        this.attachMetaAll.attachMetaC
                    );
                    if (JSON.parse(jsonStringA).items.length !== 0) {
                        this.attachMetaA = JSON.parse(jsonStringA);
                    }
                    if (JSON.parse(jsonStringB).items.length !== 0) {
                        this.attachMetaB = JSON.parse(jsonStringB);
                    }
                    if (JSON.parse(jsonStringB).items.length !== 0) {
                        this.attachMetaC = JSON.parse(jsonStringC);
                    }
                }
            }
        },
        close() {
            if (this.type === "query") {
                this.$router.push({
                    name: "reimbursement",
                });
            } else if (this.type === "adminQuery") {
                this.$router.push({
                    name: "reimbursementAdmin",
                });
            }

            this.$emit("on-update");
        },
        //计算金额
        calculate() {
            if (this.props.qty) {
                if (this.props.ddp) {
                    var m = 0;
                    var s1 = this.props.qty.toString();
                    var s2 = this.props.ddp.toString();
                    try {
                        m += s1.split(".")[1].length;
                    } catch (e) {}
                    try {
                        m += s2.split(".")[1].length;
                    } catch (e) {}
                    this.formData.reimbursementAmount =
                        (Number(s1.replace(".", "")) *
                            Number(s2.replace(".", ""))) /
                        Math.pow(10, m);
                }
            }
        },
        calculateDetail() {
            if (this.detailProps.qty) {
                if (this.detailProps.ddp) {
                    var m = 0;
                    var s1 = this.detailProps.qty.toString();
                    var s2 = this.detailProps.ddp.toString();
                    try {
                        m += s1.split(".")[1].length;
                    } catch (e) {}
                    try {
                        m += s2.split(".")[1].length;
                    } catch (e) {}
                    this.formDetail.reimbursementAmount =
                        (Number(s1.replace(".", "")) *
                            Number(s2.replace(".", ""))) /
                        Math.pow(10, m);
                }
            }
        },
        //计算金额
        calculateFee() {
            if (
                this.props.containFee ||
                this.props.frameFee ||
                this.props.otherFee
            ) {
                var m = 0;
                if (this.props.containFee) {
                    m += this.props.containFee;
                }
                if (this.props.frameFee) {
                    m += this.props.frameFee;
                }
                if (this.props.otherFee) {
                    m += this.props.otherFee;
                }

                this.formData.reimbursementAmount = Number(m).toFixed(4);
            }
        },
        //sku联动fob
        changeBySku() {
            var sku;
            if (
                this.formData.reimbursementReason === 1 ||
                this.formData.reimbursementReason === 13
            ) {
                if (!this.props.erpsku) {
                    return;
                } else {
                    sku = this.props.erpsku;
                }
            } else if (this.formData.reimbursementReason === 3) {
                if (!this.props.shouldErpsku) {
                    return;
                } else {
                    sku = this.props.shouldErpsku;
                }
            }
            HttpFindBySku({
                contextId: global.SYSID,
                erpSku: sku,
            }).then(
                (res) => {
                    if (res.data) {
                        this.props.fob = res.data.fobPrice;
                    } else {
                        if (
                            this.formData.reimbursementReason === 1 ||
                            this.formData.reimbursementReason === 13
                        ) {
                            this.props.erpsku = "";
                            this.$VMessage.error("当前组织下无该SKU");
                        }
                    }
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        //发货订单号联动
        async changeOrderNo() {
            if (this.props.shippingNo) {
                //验证发货订单号
                let flag = false;
                //验证索赔单内是否重复
                await HttpReimbursements({
                    search: {
                        IN_status: [1, 2, 3, 4, 5],
                        EQ_reimbursementReason: 3,
                        CN_props: '"shippingNo":"' + this.props.shippingNo,
                    },
                }).then(
                    (res) => {
                        if (res.data.length != 0) {
                            if (this.id) {
                                res.data.filter((item) => {
                                    if (item.id != this.id) {
                                        flag = true;
                                    }
                                });
                            } else {
                                flag = true;
                            }
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
                if (flag) {
                    this.$VMessage.error("该发货订单号已存在索赔单");
                    this.props.shippingNo = "";
                    return;
                } else {
                    HttpOrderId({
                        contextId: global.SYSID,
                        orderId: this.props.shippingNo,
                    }).then(
                        (res) => {
                            if (res.data.baseInfo) {
                                this.formData.lineId = res.data.baseInfo.lineId;
                            }

                            if (res.data.logistics) {
                                if (res.data.logistics.orgWarehouseId) {
                                    this.saleWarehouse =
                                        this.getWarehouseList.filter((item) => {
                                            return (
                                                item.value ==
                                                res.data.logistics
                                                    .orgWarehouseId
                                            );
                                        })[0];
                                    this.props.warehouseId =
                                        this.saleWarehouse.value;
                                    this.props.warehouseCode =
                                        this.saleWarehouse.attach.code;
                                    this.props.warehouseName =
                                        this.saleWarehouse.label;
                                }
                            }

                            if (res.data.packages) {
                                if (res.data.packages.length == 1) {
                                    this.props.trackingNo =
                                        res.data.packages[0].trackingNo;
                                    this.props.shouldErpsku =
                                        res.data.packages[0].erpSku;
                                } else {
                                    var flag1 = false;
                                    var flag2 = false;
                                    for (
                                        var j = 1;
                                        j < res.data.packages.length;
                                        j++
                                    ) {
                                        if (
                                            res.data.packages[0].trackingNo !=
                                            res.data.packages[j].trackingNo
                                        ) {
                                            this.props.trackingNo = "";
                                            flag1 = true;
                                        }
                                        if (
                                            res.data.packages[0].erpSku !=
                                            res.data.packages[j].erpSku
                                        ) {
                                            this.props.shouldErpsku = "";
                                            flag2 = true;
                                        }
                                    }
                                    if (flag1 == false) {
                                        this.props.trackingNo =
                                            res.data.packages[0].trackingNo;
                                    }
                                    if (flag2 == false) {
                                        this.props.shouldErpsku =
                                            res.data.packages[0].erpSku;
                                    }
                                }
                            }
                            HttpReturnByOrderId({
                                contextId: global.SYSID,
                                orderId: this.props.shippingNo,
                            }).then((res) => {
                                if (res.data.length == 1) {
                                    if (
                                        res.data[0].orderServiceItemsEntityList
                                    ) {
                                        if (
                                            res.data[0]
                                                .orderServiceItemsEntityList
                                                .length == 1
                                        ) {
                                            this.props.returnSaleOrderNo =
                                                res.data[0].orderServiceItemsEntityList[0].orderServiceNo;
                                            this.props.returnSaleOrderTrackingNo =
                                                res.data[0].orderServiceItemsEntityList[0].trackingNo;
                                            this.props.actualErpsku =
                                                res.data[0].orderServiceItemsEntityList[0].erpSku;
                                            this.props.actualQty =
                                                res.data[0].orderServiceItemsEntityList[0].returnNum;
                                        } else {
                                            var flag1 = false;
                                            var flag2 = false;
                                            var flag3 = false;
                                            var flag4 = false;
                                            for (
                                                var j = 1;
                                                j <
                                                res.data[0]
                                                    .orderServiceItemsEntityList
                                                    .length;
                                                j++
                                            ) {
                                                if (
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[0]
                                                        .trackingNo !=
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[
                                                        j
                                                    ].trackingNo
                                                ) {
                                                    this.props.returnSaleOrderTrackingNo =
                                                        "";
                                                    flag1 = true;
                                                }
                                                if (
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[0]
                                                        .orderServiceNo !=
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[
                                                        j
                                                    ].orderServiceNo
                                                ) {
                                                    this.props.returnSaleOrderNo =
                                                        "";
                                                    flag2 = true;
                                                }
                                                if (
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[0]
                                                        .erpSku !=
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[
                                                        j
                                                    ].erpSku
                                                ) {
                                                    this.props.actualErpsku =
                                                        "";
                                                    flag3 = true;
                                                }
                                                if (
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[0]
                                                        .returnNum !=
                                                    res.data[0]
                                                        .orderServiceItemsEntityList[
                                                        j
                                                    ].returnNum
                                                ) {
                                                    this.props.actualQty = "";
                                                    flag4 = true;
                                                }
                                            }
                                            if (flag1 == false) {
                                                this.props.returnSaleOrderTrackingNo =
                                                    res.data[0].orderServiceItemsEntityList[0].trackingNo;
                                            }
                                            if (flag2 == false) {
                                                this.props.returnSaleOrderNo =
                                                    res.data[0].orderServiceItemsEntityList[0].orderServiceNo;
                                            }
                                            if (flag3 == false) {
                                                this.props.actualErpsku =
                                                    res.data[0].orderServiceItemsEntityList[0].erpSku;
                                            }
                                            if (flag4 == false) {
                                                this.props.actualQty =
                                                    res.data[0].orderServiceItemsEntityList[0].returnNum;
                                            }
                                        }
                                    }
                                }
                            });
                        },
                        (err) => {
                            this.$VMessage.error("查询不到该订单信息!");
                            this.props.shippingNo = "";
                        }
                    );
                }
            }
        },
        //退货单号联动
        changeByReturn() {
            if (this.props.returnSaleOrderNo) {
                HttpReturnByServiceNo({
                    contextId: global.SYSID,
                    orderServiceNo: this.props.returnSaleOrderNo,
                }).then(
                    (res) => {
                        if (res.data.orderServiceItemsEntityList.length == 1) {
                            this.props.returnSaleOrderTrackingNo =
                                res.data.orderServiceItemsEntityList[0].trackingNo;
                        } else {
                            var flag = false;
                            for (
                                var i = 1;
                                i < res.data.orderServiceItemsEntityList.length;
                                i++
                            ) {
                                if (
                                    res.data.orderServiceItemsEntityList[0]
                                        .trackingNo !=
                                    res.data.orderServiceItemsEntityList[i]
                                        .trackingNo
                                ) {
                                    this.props.returnSaleOrderTrackingNo = "";
                                    flag = true;
                                }
                            }
                            if (flag == false) {
                                this.props.returnSaleOrderTrackingNo =
                                    res.data.orderServiceItemsEntityList[0].trackingNo;
                            }
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
        },
        //尾程 根据TrackingNo联动
        async changeTrackingNo() {
            if (this.props.trackingNo) {
                //验证索赔单内发货Tracking是否重复
                let flag = false;
                await HttpReimbursements({
                    search: {
                        IN_status: [1, 2, 3, 4, 5],
                        EQ_reimbursementType: 2,
                        CN_props: '"trackingNo":"' + this.props.trackingNo,
                    },
                }).then(
                    (res) => {
                        if (res.data.length != 0) {
                            if (this.id) {
                                res.data.filter((item) => {
                                    if (item.id != this.id) {
                                        flag = true;
                                    }
                                });
                            } else {
                                flag = true;
                            }
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
                if (flag) {
                    this.$VMessage.error("该发货Tracking已存在索赔单");
                    this.props.trackingNo = "";
                    return;
                } else {
                    HttpFindOneByTrackingNo({
                        contextId: global.SYSID,
                        trackingNo: this.props.trackingNo,
                    }).then(
                        (res) => {
                            this.trackingShow = false;
                            if (res.data.baseInfo) {
                                this.formData.lineId = res.data.baseInfo.lineId;
                                this.props.shippingNo =
                                    res.data.baseInfo.orderId;
                            }
                            if (res.data.logistics) {
                                this.props.saleCarrier =
                                    res.data.logistics.shippingMethodCode;
                                this.props.isInsurance =
                                    res.data.logistics.isInsurance == "N"
                                        ? 0
                                        : 1;
                                if (res.data.logistics.orgWarehouseId) {
                                    this.props.warehouseId =
                                        res.data.logistics.orgWarehouseId;
                                }
                            }
                            if (res.data.packages) {
                                if (res.data.packages.length == 1) {
                                    this.props.erpsku =
                                        res.data.packages[0].erpSku;
                                    this.props.qty =
                                        res.data.packages[0].shipedQuantity;
                                } else {
                                    var flag3 = false;
                                    for (
                                        var j = 1;
                                        j < res.data.packages.length;
                                        j++
                                    ) {
                                        if (
                                            res.data.packages[0].erpSku !=
                                            res.data.packages[j].erpSku
                                        ) {
                                            this.props.erpsku = "";
                                            this.props.qty = "";
                                            flag3 = true;
                                        }
                                    }
                                    if (flag3 == false) {
                                        this.props.erpsku =
                                            res.data.packages[0].erpSku;
                                        this.props.qty =
                                            res.data.packages[0].shipedQuantity;
                                    }
                                }
                            }
                        },
                        (err) => {
                            HttpGetTrackingNoByLabel({
                                trackingNo: this.props.trackingNo,
                            }).then(
                                (res) => {
                                    this.props.saleCarrier = res.data.carrier;
                                    this.props.logisticsServiceCode =
                                        res.data.logisticsServiceCode;
                                    this.formData.hostOrgId = 1000615;
                                    this.trackingShow = true;
                                },
                                (err) => {
                                    this.props.trackingNo = "";
                                    this.props.erpsku = "";
                                    this.props.qty = "";
                                    this.props.saleCarrier = "";
                                    this.props.logisticsServiceCode = "";
                                    this.props.shippingNo = "";
                                    this.props.warehouseId = "";
                                    this.$VMessage.error("没有该发货Tracking");
                                }
                            );
                        }
                    );
                }
            }
        },
        //入库计划单根据多个单号查询
        async changeInboundPlanOrderNos() {
            if (this.props.inBoundOrderNo) {
                this.props.warehouseName = "";
                this.props.packedNo = "";
                let reg = new RegExp("，", "g"); //g代表全部
                var flag = false;
                this.props.inBoundOrderNo = this.props.inBoundOrderNo.replace(
                    reg,
                    ","
                );
                const arr = this.props.inBoundOrderNo.split(",");
                console.log(arr);
                for (var i = 0; i < arr.length; i++) {
                    const inNo = arr[i];
                    await HttpInboundPlanCheck({
                        contextId: global.SYSID,
                        inboundPlanOrderNo: arr[i],
                    }).then((res) => {
                        if (!res.data) {
                            this.$VMessage.error(
                                "入库计划单号:" + inNo + "不在该组织下！"
                            );
                            console.log(88888);
                            this.props.warehouseName = "";
                            this.props.packedNo = "";
                            this.props.inBoundOrderNo = "";
                            flag = true;
                        }
                    });
                }
                if (flag == false) {
                    HttpInboundPlanOrderNos({
                        organizationId: global.SYSID,
                        inboundPlanOrderNos: this.props.inBoundOrderNo,
                    }).then(
                        (res) => {
                            if (res.data.length == 1) {
                                console.log(res.data[0]);
                                if (res.data[0].orgWarehouseId) {
                                    this.saleWarehouse =
                                        this.getWarehouseList.filter((item) => {
                                            return (
                                                item.value ==
                                                res.data[0].orgWarehouseId
                                            );
                                        })[0];
                                    this.props.warehouseId =
                                        this.saleWarehouse.value;
                                    this.props.warehouseCode =
                                        this.saleWarehouse.attach.code;
                                    this.props.warehouseName =
                                        this.saleWarehouse.label;
                                }
                                if (res.data[0].lineId) {
                                    this.formData.lineId = res.data[0].lineId;
                                }
                                if (res.data[0].gpCartonNo20) {
                                    if (res.data[0].gpCartonNo20.length == 11) {
                                        this.props.packedNo =
                                            res.data[0].gpCartonNo20;
                                    }
                                }
                                if (res.data[0].gpCartonNo40) {
                                    if (res.data[0].gpCartonNo40.length == 11) {
                                        this.props.packedNo =
                                            res.data[0].gpCartonNo40;
                                    }
                                }
                                if (res.data[0].hqCartonNo40) {
                                    if (res.data[0].hqCartonNo40.length == 11) {
                                        this.props.packedNo =
                                            res.data[0].hqCartonNo40;
                                    }
                                }
                                if (res.data[0].hqCartonNo45) {
                                    if (res.data[0].hqCartonNo45.length == 11) {
                                        this.props.packedNo =
                                            res.data[0].hqCartonNo45;
                                    }
                                }
                            } else {
                                var flag1 = false;
                                var flag2 = false;
                                var flag3 = false;
                                var flag4 = false;
                                var flag5 = false;
                                var flag6 = false;
                                for (var j = 1; j < res.data.length; j++) {
                                    if (
                                        res.data[0].orgWarehouseId !=
                                        res.data[j].orgWarehouseId
                                    ) {
                                        this.$VMessage.error(
                                            "入库计划单必须为同一个仓库！"
                                        );
                                        this.props.warehouseName = "";
                                        return;
                                    }
                                    if (
                                        res.data[0].lineId != res.data[j].lineId
                                    ) {
                                        this.formData.lineId = "";
                                        flag6 = true;
                                    }
                                    if (res.data[0].gpCartonNo20) {
                                        if (
                                            res.data[0].gpCartonNo20 !=
                                            res.data[j].gpCartonNo20
                                        ) {
                                            this.props.packedNo = "";
                                            flag2 = true;
                                        }
                                    } else if (res.data[0].gpCartonNo40) {
                                        if (
                                            res.data[0].gpCartonNo40 !=
                                            res.data[j].gpCartonNo40
                                        ) {
                                            this.props.packedNo = "";
                                            flag3 = true;
                                        }
                                    } else if (res.data[0].hqCartonNo40) {
                                        if (
                                            res.data[0].hqCartonNo40 !=
                                            res.data[j].hqCartonNo40
                                        ) {
                                            this.props.packedNo = "";
                                            flag4 = true;
                                        }
                                    } else if (res.data[0].hqCartonNo45) {
                                        if (
                                            res.data[0].hqCartonNo45 !=
                                            res.data[j].hqCartonNo45
                                        ) {
                                            this.props.packedNo = "";
                                            flag5 = true;
                                        }
                                    }
                                }
                                if (flag1 == false) {
                                    this.saleWarehouse =
                                        this.getWarehouseList.filter((item) => {
                                            return (
                                                item.value ==
                                                res.data[0].orgWarehouseId
                                            );
                                        })[0];
                                    this.props.warehouseId =
                                        this.saleWarehouse.value;
                                    this.props.warehouseCode =
                                        this.saleWarehouse.attach.code;
                                    this.props.warehouseName =
                                        this.saleWarehouse.label;
                                }
                                if (flag2 == false) {
                                    if (res.data[0].gpCartonNo20) {
                                        if (
                                            res.data[0].gpCartonNo20.length ==
                                            11
                                        ) {
                                            this.props.packedNo =
                                                res.data[0].gpCartonNo20;
                                        }
                                    }
                                }
                                if (flag3 == false) {
                                    if (res.data[0].gpCartonNo40) {
                                        if (
                                            res.data[0].gpCartonNo40.length ==
                                            11
                                        ) {
                                            this.props.packedNo =
                                                res.data[0].gpCartonNo40;
                                        }
                                    }
                                }
                                if (flag4 == false) {
                                    if (res.data[0].hqCartonNo40) {
                                        if (
                                            res.data[0].hqCartonNo40.length ==
                                            11
                                        ) {
                                            this.props.packedNo =
                                                res.data[0].hqCartonNo40;
                                        }
                                    }
                                }
                                if (flag5 == false) {
                                    if (res.data[0].hqCartonNo45) {
                                        if (
                                            res.data[0].hqCartonNo45.length ==
                                            11
                                        ) {
                                            this.props.packedNo =
                                                res.data[0].hqCartonNo45;
                                        }
                                    }
                                }

                                if (flag6 == false) {
                                    if (res.data[0].lineId) {
                                        this.formData.lineId =
                                            res.data[0].lineId;
                                    }
                                }
                            }
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                } else {
                    this.props.warehouseName = "";
                    this.props.packedNo = "";
                    this.props.inBoundOrderNo = "";
                    this.formData.lineId = "";
                }
            }
        },
        //索赔明细里联动
        async changeTrackingNoDetail() {
            if (this.detailProps.trackingNo) {
                this.detailProps.dispatchNo = "";
                this.detailProps.warehouseId = "";
                this.detailProps.warehouseCode = "";
                this.detailProps.warehouseName = "";
                this.detailProps.saleCarrier = "";
                this.detailProps.erpsku = "";
                var flag = false;
                //验证索赔单明细内发货Tracking是否重复
                await HttpReimbursementDetail({
                    search: {
                        EQ_headId: this.formData.id,
                    },
                }).then(
                    (res) => {
                        res.data.content.filter((item) => {
                            if (
                                JSON.parse(item.detailProps).trackingNo ==
                                this.detailProps.trackingNo
                            ) {
                                flag = true;
                            }
                        });
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
                if (flag) {
                    this.$VMessage.error("在当前索赔单中已存在该发货Tracking");
                    this.detailProps.trackingNo = "";
                    return;
                } else {
                    HttpFindByTrackingNoNew({
                        contextId: global.SYSID,
                        trackingNo: this.detailProps.trackingNo,
                    }).then(
                        (res) => {
                            if (res.data.b2cOrder) {
                                if (res.data.b2cOrder.baseInfo) {
                                    this.detailProps.dispatchNo =
                                        res.data.b2cOrder.baseInfo.orderId;
                                }
                                if (res.data.b2cOrder.logistics) {
                                    if (
                                        res.data.b2cOrder.logistics
                                            .orgWarehouseId
                                    ) {
                                        this.detailProps.warehouseId =
                                            res.data.b2cOrder.logistics.orgWarehouseId;
                                        this.detailProps.warehouseCode =
                                            this.getWarehouseList.filter(
                                                (item) => {
                                                    return (
                                                        item.value ==
                                                        this.detailProps
                                                            .warehouseId
                                                    );
                                                }
                                            )[0].attach.code;
                                        this.detailProps.warehouseName =
                                            this.getWarehouseList.filter(
                                                (item) => {
                                                    return (
                                                        item.value ==
                                                        this.detailProps
                                                            .warehouseId
                                                    );
                                                }
                                            )[0].label;
                                    }
                                }
                                if (res.data.b2cOrder.packages) {
                                    let carrierArr = [];
                                    let skuArr = [];
                                    res.data.b2cOrder.packages.map((item) => {
                                        if (
                                            carrierArr.indexOf(item.carrier) < 0
                                        )
                                            carrierArr.push(item.carrier);
                                        if (skuArr.indexOf(item.erpSku) < 0)
                                            skuArr.push(item.erpSku);
                                    });
                                    if (carrierArr.length == 1)
                                        this.detailProps.saleCarrier =
                                            carrierArr[0];
                                    if (skuArr.length == 1)
                                        this.detailProps.erpsku = skuArr[0];
                                }
                            }
                            if (res.data.orderService) {
                                if (res.data.orderService.orderId) {
                                    this.detailProps.dispatchNo =
                                        res.data.orderService.orderId;
                                }
                                if (res.data.orderService.orgWarehouseId) {
                                    this.detailProps.warehouseId =
                                        res.data.orderService.orgWarehouseId;
                                    this.detailProps.warehouseCode =
                                        this.getWarehouseList.filter((item) => {
                                            return (
                                                item.value ==
                                                this.detailProps.warehouseId
                                            );
                                        })[0].attach.code;
                                    this.detailProps.warehouseName =
                                        this.getWarehouseList.filter((item) => {
                                            return (
                                                item.value ==
                                                this.detailProps.warehouseId
                                            );
                                        })[0].label;
                                }
                                if (
                                    res.data.orderService
                                        .orderServiceItemsEntityList
                                ) {
                                    let carrierArr = [];
                                    let skuArr = [];
                                    res.data.orderService.orderServiceItemsEntityList.map(
                                        (item) => {
                                            if (
                                                carrierArr.indexOf(
                                                    item.carrier
                                                ) < 0
                                            )
                                                carrierArr.push(
                                                    item.returnMode
                                                );
                                            if (skuArr.indexOf(item.erpSku) < 0)
                                                skuArr.push(item.erpSku);
                                        }
                                    );
                                    if (carrierArr.length == 1)
                                        this.detailProps.saleCarrier =
                                            carrierArr[0];
                                    if (skuArr.length == 1)
                                        this.detailProps.erpsku = skuArr[0];
                                }
                            }
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                    // HttpFindOneByTrackingNo({
                    //   contextId: global.SYSID,
                    //   trackingNo: this.detailProps.trackingNo
                    // }).then(
                    //   res => {
                    //     if (res.data.baseInfo) {
                    //       this.detailProps.dispatchNo = res.data.baseInfo.orderId;
                    //     }
                    //     if (res.data.logistics) {
                    //       if (res.data.logistics.orgWarehouseId) {
                    //         this.detailProps.warehouseId = res.data.logistics.orgWarehouseId;
                    //         this.detailProps.warehouseCode = this.getWarehouseList.filter(item => {return item.value == this.detailProps.warehouseId;})[0].attach.code;
                    //         this.detailProps.warehouseName = this.getWarehouseList.filter(item => {return item.value == this.detailProps.warehouseId;})[0].label;
                    //       }
                    //     }
                    //     if (res.data.packages) {
                    //       if (res.data.packages.length == 1) {
                    //         this.detailProps.saleCarrier = res.data.packages[0].carrier;
                    //         this.detailProps.erpsku = res.data.packages[0].erpSku;
                    //       } else {
                    //         var flag1 = false;
                    //         var flag2 = false;
                    //         for (var j = 1; j < res.data.packages.length; j++) {
                    //           if (res.data.packages[0].carrier != res.data.packages[j].carrier) {
                    //             flag1 = true;
                    //           }
                    //           if (res.data.packages[0].erpSku != res.data.packages[j].erpSku) {
                    //             flag2 = true;
                    //           }
                    //         }
                    //         if (!flag1) {
                    //           this.detailProps.saleCarrier = res.data.packages[0].carrier;
                    //         }
                    //         if (!flag2) {
                    //           this.detailProps.erpsku = res.data.packages[0].erpSku;
                    //         }
                    //       }
                    //     }
                    //   },
                    //   err => {
                    //     HttpGetReturnByTrackingNo({
                    //       contextId: global.SYSID,
                    //       trackingNo: this.detailProps.trackingNo
                    //     }).then(
                    //     res => {
                    //         if(res.data.orderId){
                    //             this.detailProps.dispatchNo = res.data.orderId;
                    //         }
                    //          if (res.data.orgWarehouseId) {
                    //             this.detailProps.warehouseId = res.data.orgWarehouseId;
                    //             this.detailProps.warehouseCode = this.getWarehouseList.filter(item => {return item.value == this.detailProps.warehouseId;})[0].attach.code;
                    //             this.detailProps.warehouseName = this.getWarehouseList.filter(item => {return item.value == this.detailProps.warehouseId;})[0].label;
                    //         }
                    //             console.log(this.detailProps )
                    //         if (res.data.orderServiceItemsEntityList.length == 1) {
                    //             this.detailProps.saleCarrier = res.data.orderServiceItemsEntityList[0].returnMode;
                    //             this.detailProps.erpsku = res.data.orderServiceItemsEntityList[0].erpSku;
                    //         } else {
                    //             var flag1 = false;
                    //             var flag2 = false;
                    //             for (var j = 1; j < res.data.orderServiceItemsEntityList.length; j++) {
                    //           if (res.data.orderServiceItemsEntityList[0].returnMode != res.data.orderServiceItemsEntityList[j].returnMode) {
                    //             flag1 = true;
                    //           }
                    //           if (res.data.orderServiceItemsEntityList[0].erpSku != res.data.orderServiceItemsEntityList[j].erpSku) {
                    //             flag2 = true;
                    //           }
                    //         }
                    //         if (flag1 == false) {
                    //           this.detailProps.saleCarrier = res.data.orderServiceItemsEntityList[0].returnMode;
                    //         }
                    //         if (flag2 == false) {
                    //           this.detailProps.erpsku = res.data.orderServiceItemsEntityList[0].erpSku;
                    //         }
                    //       }
                    //     },
                    //     err => {
                    //       this.$VMessage.error(err.message);
                    //     }
                    //     )

                    //   }
                    // );
                }
            }
        },
        //尾程类型退货trackingNo
        async findReturnByTrackingNo() {
            console.log(this);
            if (this.props.trackingNo) {
                //验证索赔单内发货Tracking是否重复
                let flag = false;
                await HttpReimbursements({
                    search: {
                        IN_status: [1, 2, 3, 4, 5],
                        EQ_reimbursementType: 2,
                        CN_props: '"trackingNo":"' + this.props.trackingNo,
                    },
                }).then(
                    (res) => {
                        if (res.data.length != 0) {
                            if (this.id) {
                                res.data.filter((item) => {
                                    if (item.id != this.id) {
                                        flag = true;
                                    }
                                });
                            } else {
                                flag = true;
                            }
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
                if (flag) {
                    this.$VMessage.error("该退货Tracking已存在索赔单");
                    this.props.trackingNo = "";
                    return;
                } else {
                    HttpGetFbbReturnByTrackingNo({
                        contextId: global.SYSID,
                        trackingNo: this.props.trackingNo,
                    }).then(
                        (res) => {
                            if (
                                res.data.saleReturnPlanOrderBaseInfo.saleOrderNo
                            ) {
                                this.props.shippingNo =
                                    res.data.saleReturnPlanOrderBaseInfo.saleOrderNo;
                            }
                            if (
                                res.data.saleReturnPlanOrderBaseInfo.carrierCode
                            ) {
                                this.props.saleCarrier =
                                    res.data.saleReturnPlanOrderBaseInfo.carrierCode;
                            }
                            if (res.data.saleReturnPlanOrderBaseInfo.lineId) {
                                this.formData.lineId =
                                    res.data.saleReturnPlanOrderBaseInfo.lineId;
                            }
                            if (
                                res.data.saleReturnPlanOrderBaseInfo
                                    .orgWarehouseId
                            ) {
                                this.props.warehouseId =
                                    res.data.saleReturnPlanOrderBaseInfo.orgWarehouseId;
                            }
                            if (res.data.saleReturnPlanOrderItems.length == 1) {
                                this.props.erpsku =
                                    res.data.saleReturnPlanOrderItems[0].sku;
                                this.props.qty =
                                    res.data.saleReturnPlanOrderItems[0].qty;
                            } else {
                                var flag1 = false;
                                var flag2 = false;
                                for (
                                    var j = 1;
                                    j <
                                    res.data.saleReturnPlanOrderItems.length;
                                    j++
                                ) {
                                    if (
                                        res.data.saleReturnPlanOrderItems[0]
                                            .sku !=
                                        res.data.saleReturnPlanOrderItems[j].sku
                                    ) {
                                        flag1 = true;
                                    }
                                    if (
                                        res.data.saleReturnPlanOrderItems[0]
                                            .qty !=
                                        res.data.saleReturnPlanOrderItems[j].qty
                                    ) {
                                        flag2 = true;
                                    }
                                }
                                if (flag1 == false) {
                                    this.props.erpsku =
                                        res.data.saleReturnPlanOrderItems[0].sku;
                                }
                                if (flag2 == false) {
                                    this.props.qty =
                                        res.data.saleReturnPlanOrderItems[0].qty;
                                }
                            }
                        },
                        (err) => {
                            this.props.trackingNo = "";
                            this.props.erpsku = "";
                            this.props.qty = "";
                            this.props.saleCarrier = "";
                            this.props.logisticsServiceCode = "";
                            this.props.shippingNo = "";
                            this.props.warehouseId = "";
                            this.$VMessage.error("没有该退货Tracking");
                        }
                    );
                }
            }
        },
        //导入明细
        importDetail() {
            let that = this;
            this.modalProps = {
                show: true,
                title: "导入数据",
                showFooter: false,
                component: "compUpload",
                width: 520,
                props: {
                    data: { headId: that.formData.id, contextId: global.SYSID },
                    action:
                        process.env.VUE_APP_APIURL_FBB +
                        "/api/v2/reimbursement/ReimbursementDetail/importReimbursementDetail",
                    name: "excelFile",
                    download: () => {
                        if (
                            that.props.billType === 1 ||
                            that.props.billType === 3 ||
                            that.props.billType === 4
                        ) {
                            this.handleWebfs(
                                "/static/template/reimbursement_detail_inv.xlsx",
                                {},
                                {
                                    executor: "download",
                                    type: "url",
                                }
                            );
                        } else if (that.props.billType === 2) {
                            this.handleWebfs(
                                "/static/template/reimbursement_detail_storage.xlsx",
                                {},
                                {
                                    executor: "download",
                                    type: "url",
                                }
                            );
                        } else if (
                            that.props.billType === 5 ||
                            that.props.billType === 6 ||
                            that.props.billType === 7 ||
                            that.props.billType === 8 ||
                            that.props.billType === 9
                        ) {
                            this.handleWebfs(
                                "/static/template/reimbursement_detail_ship.xlsx",
                                {},
                                {
                                    executor: "download",
                                    type: "url",
                                }
                            );
                        } else if (that.formData.reimbursementType === 4) {
                            this.handleWebfs(
                                "/static/template/reimbursement_detail_shipHead.xlsx",
                                {},
                                {
                                    executor: "download",
                                    type: "url",
                                }
                            );
                        }
                        /*  switch (that.props.billType) {
              case 1:
              case 3:
              case 4:
                this.handleWebfs(
                  "/static/template/reimbursement_detail_inv.xlsx",
                  {},
                  {
                    executor: "download",
                    type: "url"
                  }
                );
                break;
              case 2:
                this.handleWebfs(
                  "/static/template/reimbursement_detail_storage.xlsx",
                  {},
                  {
                    executor: "download",
                    type: "url"
                  }
                );
                break;
              case 5:
              case 6:
              case 7:
              case 8:
              case 9:
                this.handleWebfs(
                  "/static/template/reimbursement_detail_ship.xlsx",
                  {},
                  {
                    executor: "download",
                    type: "url"
                  }
                );
                break;
            } */
                    },
                },
                on: {
                    "on-success": (row) => {
                        this.startUp += 1;
                        /*  row.data.forEach(item => {
              this.addItem({ outPlanqty: item.qty, sku: item.sku });
            }); */
                        HttpReimbursementDetail({
                            search: {
                                EQ_headId: that.formData.id,
                            },
                            rows: 1000,
                        }).then(
                            (res) => {
                                let sum = 0;
                                res.data.content.forEach((item) => {
                                    //遍历reimbursementAmount这个字段，并累加
                                    sum += item.reimbursementAmount;
                                });
                                this.formData.reimbursementAmount = sum;
                                //保存头单据
                                HttpReimbursementSave({ ...this.formData });
                            },
                            (err) => {
                                this.$VMessage.error(err.message);
                            }
                        );
                        this.modalProps.show = false;
                    },
                },
            };
        },
        //导出明细
        exportDetail() {
            this.handleWebfs(
                /* "http://127.0.0.1:3221" */
                process.env.VUE_APP_APIURL_FBB +
                    "/api/v2/reimbursement/ReimbursementDetail/exportDetail",
                { headId: this.formData.id },
                "download"
            );
        },
        //调账
        checkBill() {
            this.attachMetas.items = [];
            let that = this;
            this.modalProps = {
                show: true,
                alert: "success",
                width: 460,
                title: "调账",
                component: compModals,
                showFooter: false,
                showDesc: false,
                props: {
                    headId: that.id,
                    type: "checkBill",
                },
            };
        },
        complete() {
            this.modalProps = {
                show: true,
                alert: "success",
                title: "完成",
                width: 460,
                showDesc: false,
                callback: this.goback,
                params: {
                    headId: this.id,
                    opAction: 9,
                },
                ajaxRequest: HttplogOrderAction,
                formdata: [
                    {
                        tag: "vRadio",
                        key: "isComplete",
                        labelWidth: "auto",
                        default: 1,
                        show:
                            this.formData.reimbursementType == 2 ||
                            this.formData.reimbursementReason == 10,
                        span: 24,
                        options: [
                            {
                                trueValue: 1,
                                label: "索赔成功",
                            },
                            {
                                trueValue: 2,
                                label: "索赔失败",
                            },
                        ],
                    },
                    {
                        tag: "vTextarea",
                        key: "opData",
                        labelWidth: "auto",
                        span: 24,
                        label: "备注原因",
                        required: false,
                    },
                ],
            };
        },
        cancelReimbursement() {
            this.modalProps = {
                show: true,
                alert: "error",
                title: "取消",
                width: 460,
                showDesc: false,
                callback: this.goback,
                params: {
                    headId: this.id,
                    opAction: 7,
                },
                ajaxRequest: HttplogOrderAction,
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "opData",
                        labelWidth: "auto",
                        span: 24,
                        label: "取消原因",
                    },
                ],
            };
        },
        addRemark() {
            this.attachMetas.items = [];
            let that = this;
            this.modalProps = {
                show: true,
                alert: "success",
                width: 460,
                title: "备注",
                component: compModals,
                showFooter: false,
                showDesc: false,
                props: {
                    headId: that.id,
                    type: "addRemark",
                },
                /* on: {
          "on-success": row => {
            this.modalProps.show = false;
          }
        } */
            };
        },

        //撤销审核
        cancelAudit() {
            this.modalProps = {
                show: true,
                title: "撤销审核",
                alert: "success",
                width: "300px",
                callback: this.goback,
                params: { headId: this.id, opAction: 3 },
                ajaxRequest: HttplogOrderAction,
            };
        },
        audit() {
            this.attachMetas.items = [];
            let that = this;
            this.modalProps = {
                show: true,
                alert: "info",
                title: "审核",
                width: "400px",
                showDesc: false,
                callback: this.goback,
                component: compModals,
                showFooter: false,
                props: {
                    headId: that.id,
                    type: "aduit",
                },

                /* params: {
          headId: this.id
        },
        ajaxRequest: HttplogOrderAction,
        formdata: [
          {
            tag: "vRadio",
            key: "opAction",
            labelWidth: "auto",
            default: 4,
            span: 24,
            label: "审核",
            options: [
              {
                trueValue: 4,
                label: "审核通过"
              },
              {
                trueValue: 5,
                label: "审核拒回"
              }
            ]
          },
           {
            label: "复核日期",
            tag: "vDatepicker",
            labelWidth: "auto",
            key: "reviewAt",
            span: 24,
            props: {
              format: "yy-mm-dd"
            },
            required: false
          },
          {
            tag: "vTextarea",
            key: "opData",
            labelWidth: "auto",
            span: 24,
            label: "备注",
            required: false
          }
        ] */
            };
        },
        toAudit() {
            this.modalProps = {
                show: true,
                title: "提交审核",
                alert: "success",
                width: "300px",
                callback: this.goback,
                params: { headId: this.id, opAction: 2 },
                ajaxRequest: HttplogOrderAction,
            };
        },
        goback() {
            this.refreshPage();
        },

        //删除
        removeItems() {
            const ids = this.$refs.tableList.checkedData;
            /* const ids = this.checkData.join(","); */
            if (!ids.length) {
                this.$VMessage.warning("请选择至少一条数据");
                return;
            }
            this.modalProps = {
                show: true,
                title: "删除",
                alert: "warning",
                width: "300px",
                params: {
                    contextId: global.SYSID,
                    ids: ids,
                },
                ajaxRequest: HttpReimbursementRemove,
                callback: () => {
                    HttpReimbursementDetail({
                        search: {
                            EQ_headId: this.formData.id,
                        },
                        rows: 1000,
                    }).then(
                        (res) => {
                            let sum = 0;
                            res.data.content.forEach((item) => {
                                //遍历reimbursementAmount这个字段，并累加
                                sum += item.reimbursementAmount;
                            });
                            this.formData.reimbursementAmount = sum;
                            //保存头单据
                            HttpReimbursementSave({ ...this.formData });
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                    this.startUp += 1;
                    /* this.getDetail(); */
                },
            };
        },
        clearAll() {
            this.modalProps = {
                show: true,
                title: "清空所有",
                alert: "error",
                params: {
                    contextId: global.SYSID,
                    headId: this.formData.id,
                },
                ajaxRequest: HttpClearReimbursementDetail,
                callback: () => {
                    this.formData.reimbursementAmount = 0.0001;
                    //保存头单据
                    HttpReimbursementSave({ ...this.formData });
                    this.startUp += 1;
                },
            };
        },
    },
};
</script>
<style lang="scss">
.reimbursementUpload {
    .upload {
        .upload-item {
            display: flex;
            color: #3399ff;
            .filename {
                width: 40%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .close {
                margin-left: 5px;
                &:hover {
                    color: red;
                    cursor: pointer;
                }
            }
        }
    }
}
.prop-file-parent {
    position: relative;
}
.propFile {
    position: absolute;
    left: 35px;
}
.props-file-text {
    position: absolute;
    bottom: -27px;
    left: 101px;
}
</style>
